unit Offgrids;

interface

uses
  SysUtils, Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, WEBLib.Imaging.pngimage, WEBLib.ExtCtrls,
  WEBLib.StdCtrls, Math, WEBLib.Imaging.jpeg;

type
  TForm1 = class(TForm)
    WebLabel1: TLabel;
    WebImageControl1: TImageControl;
    WebGroupBox1: TGroupBox;
    WebLabel2: TLabel;
    WebLabel3: TLabel;
    WebLabel4: TLabel;
    WebComboBox1: TComboBox;
    WebLabel6: TLabel;
    WebComboBox2: TComboBox;
    WebGroupBox2: TGroupBox;
    WebEdit2: TEdit;
    WebLabel7: TLabel;
    WebLabel8: TLabel;
    WebEdit3: TEdit;
    WebLabel11: TLabel;
    WebComboBox3: TComboBox;
    WebComboBox4: TComboBox;
    WebLabel14: TLabel;
    WebLabel15: TLabel;
    WebLabel12: TLabel;
    WebLabel17: TLabel;
    WebImageControl2: TImageControl;
    WebLabel18: TLabel;
    WebLabel19: TLabel;
    WebLabel20: TLabel;
    WebLabel21: TLabel;
    WebLabel22: TLabel;
    WebLabel23: TLabel;
    WebLabel24: TLabel;
    WebLabel25: TLabel;
    WebLabel26: TLabel;
    WebLabel27: TLabel;
    WebLabel28: TLabel;
    WebLabel29: TLabel;
    WebEdit4: TEdit;
    WebEdit5: TEdit;
    WebEdit6: TEdit;
    WebEdit7: TEdit;
    WebEdit8: TEdit;
    WebEdit9: TEdit;
    WebEdit10: TEdit;
    WebEdit11: TEdit;
    WebEdit12: TEdit;
    WebEdit13: TEdit;
    WebEdit14: TEdit;
    WebEdit15: TEdit;
    WebEdit16: TEdit;
    WebEdit17: TEdit;
    WebEdit18: TEdit;
    WebEdit19: TEdit;
    WebEdit20: TEdit;
    WebEdit21: TEdit;
    WebEdit22: TEdit;
    WebEdit23: TEdit;
    WebEdit24: TEdit;
    WebEdit25: TEdit;
    WebEdit26: TEdit;
    WebEdit27: TEdit;
    WebEdit28: TEdit;
    WebEdit29: TEdit;
    WebEdit30: TEdit;
    WebEdit31: TEdit;
    WebEdit32: TEdit;
    WebEdit33: TEdit;
    WebEdit34: TEdit;
    WebEdit35: TEdit;
    WebEdit36: TEdit;
    WebEdit37: TEdit;
    WebEdit38: TEdit;
    WebEdit39: TEdit;
    WebEdit40: TEdit;
    WebEdit41: TEdit;
    WebEdit42: TEdit;
    WebLabel80: TLabel;
    WebLabel81: TLabel;
    WebLabel82: TLabel;
    WebLabel83: TLabel;
    WebEdit43: TEdit;
    WebEdit44: TEdit;
    WebEdit45: TEdit;
    WebEdit46: TEdit;
    WebLabel5: TLabel;
    WebLabel30: TLabel;
    WebEdit47: TEdit;
    WebLabel31: TLabel;
    WebLabel32: TLabel;
    WebEdit48: TEdit;
    WebLabel33: TLabel;
    WebLabel34: TLabel;
    WebEdit49: TEdit;
    WebLabel35: TLabel;
    WebLabel38: TLabel;
    WebEdit51: TEdit;
    WebLabel39: TLabel;
    WebGroupBox3: TGroupBox;
    WebComboBox5: TComboBox;
    WebLabel9: TLabel;
    WebLabel10: TLabel;
    WebEdit1: TEdit;
    WebLabel13: TLabel;
    WebLabel36: TLabel;
    WebLabel16: TLabel;
    WebLabel37: TLabel;
    procedure WebComboBox1Change(Sender: TObject);
    procedure WebComboBox2Change(Sender: TObject);
    procedure WebComboBox3Change(Sender: TObject);
    procedure WebRadioButton1Click(Sender: TObject);
    procedure WebRadioButton2Click(Sender: TObject);
    procedure WebComboBox4Change(Sender: TObject);
    procedure WebEdit14KeyUp(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure WebEdit13KeyUp(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure WebEdit15KeyUp(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure WebEdit16KeyUp(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure WebEdit17KeyUp(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure WebEdit18KeyUp(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure WebEdit19KeyUp(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure WebEdit20KeyUp(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure WebEdit21KeyUp(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure WebEdit22KeyUp(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure WebEdit4KeyUp(Sender: TObject; var Key: Word; Shift: TShiftState);
    procedure WebEdit5KeyUp(Sender: TObject; var Key: Word; Shift: TShiftState);
    procedure WebEdit6KeyUp(Sender: TObject; var Key: Word; Shift: TShiftState);
    procedure WebEdit7KeyUp(Sender: TObject; var Key: Word; Shift: TShiftState);
    procedure WebEdit8KeyUp(Sender: TObject; var Key: Word; Shift: TShiftState);
    procedure WebEdit9KeyUp(Sender: TObject; var Key: Word; Shift: TShiftState);
    procedure WebEdit10KeyUp(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure WebEdit11KeyUp(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure WebEdit12KeyUp(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure WebEdit23KeyUp(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure WebEdit24KeyUp(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure WebEdit25KeyUp(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure WebEdit26KeyUp(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure WebEdit27KeyUp(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure WebEdit28KeyUp(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure WebEdit29KeyUp(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure WebEdit30KeyUp(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure WebEdit31KeyUp(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure WebEdit32KeyUp(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure WebEdit42KeyUp(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure WebEdit41KeyUp(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure WebEdit40KeyUp(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure WebEdit39KeyUp(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure WebEdit38KeyUp(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure WebEdit37KeyUp(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure WebEdit36KeyUp(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure WebEdit35KeyUp(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure WebEdit34KeyUp(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure WebEdit33KeyUp(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure WebEdit3KeyUp(Sender: TObject; var Key: Word; Shift: TShiftState);
    procedure WebComboBox5Change(Sender: TObject);
  private
    { Private declarations }
  protected
    procedure LoadDFMValues; override;
  public
    { Public declarations }
  end;

var
  Form1     : TForm1;
  Wysokosc  : array[0..23] of Real;
  Dc, SN    : Integer;
  Cj        : Real;

implementation


var nett: Double;         // Brutto-, Nettobetrag
    ust: Single;                 // Umsatzsteuer
    code: Integer;               // Hilfsvariablen

Procedure SUMA;
 var   ST, Na, Ka     : Double;
begin
   case Form1.WebComboBox2.ItemIndex of
   0: ST:=0.9;
   1: ST:=1;
   end;

   case Form1.WebComboBox4.ItemIndex of
   0: Na:=3.375;
   1: Na:=3.428;
   2: Na:=3.438;
   3: Na:=3.305;
   4: Na:=3.602;
   5: Na:=3.578;
   6: Na:=3.335;
   7: Na:=3.457;
   8: Na:=3.485;
   9: Na:=3.466;
   10: Na:=3.338;
   11: Na:=3.501;
   12: Na:=3.476;
   13: Na:=3.401;
   14: Na:=3.610;
   15: Na:=3.558;
   16: Na:=3.570;
   17: Na:=3.577;
   18: Na:=3.396;
   19: Na:=3.619;
   20: Na:=3.592;
   21: Na:=3.689;
   22: Na:=3.616;
   23: Na:=3.594;
   24: Na:=3.416;
   25: Na:=3.545;
   26: Na:=3.551;
   27: Na:=3.334;
   28: Na:=3.664;
   29: Na:=3.411;
   30: Na:=3.429;
   31: Na:=3.586;
   32: Na:=3.486;
   33: Na:=3.565;
   34: Na:=3.605;
   35: Na:=3.590;
   36: Na:=3.632;
   37: Na:=3.603;
   38: Na:=3.653;
   39: Na:=3.496;
   40: Na:=3.547;
   41: Na:=3.354;
   42: Na:=3.289;
   43: Na:=3.437;
   44: Na:=3.368;
   45: Na:=3.576;
   46: Na:=3.485;
   47: Na:=3.656;
   48: Na:=3.622;
   49: Na:=3.438;
   50: Na:=3.389;
   51: Na:=3.538;
   52: Na:=3.453;
   53: Na:=3.683;
   54: Na:=3.602;
   55: Na:=3.546;
   56: Na:=3.545;
   end;
   Form1.WebEdit33.Text:=FloattoStr(StrtoFloat(Form1.WebEdit3.Text)*StrtoFloat(Form1.WebEdit13.Text)*StrtoFloat(Form1.WebEdit23.Text));
   Form1.WebEdit34.Text:=FloattoStr(StrtoFloat(Form1.WebEdit4.Text)*StrtoFloat(Form1.WebEdit14.Text)*StrtoFloat(Form1.WebEdit24.Text));
   Form1.WebEdit35.Text:=FloattoStr(StrtoFloat(Form1.WebEdit5.Text)*StrtoFloat(Form1.WebEdit15.Text)*StrtoFloat(Form1.WebEdit25.Text));
   Form1.WebEdit36.Text:=FloattoStr(StrtoFloat(Form1.WebEdit6.Text)*StrtoFloat(Form1.WebEdit16.Text)*StrtoFloat(Form1.WebEdit26.Text));
   Form1.WebEdit37.Text:=FloattoStr(StrtoFloat(Form1.WebEdit7.Text)*StrtoFloat(Form1.WebEdit17.Text)*StrtoFloat(Form1.WebEdit27.Text));
   Form1.WebEdit38.Text:=FloattoStr(StrtoFloat(Form1.WebEdit8.Text)*StrtoFloat(Form1.WebEdit18.Text)*StrtoFloat(Form1.WebEdit28.Text));
   Form1.WebEdit39.Text:=FloattoStr(StrtoFloat(Form1.WebEdit9.Text)*StrtoFloat(Form1.WebEdit19.Text)*StrtoFloat(Form1.WebEdit29.Text));
   Form1.WebEdit40.Text:=FloattoStr(StrtoFloat(Form1.WebEdit10.Text)*StrtoFloat(Form1.WebEdit20.Text)*StrtoFloat(Form1.WebEdit30.Text));
   Form1.WebEdit41.Text:=FloattoStr(StrtoFloat(Form1.WebEdit11.Text)*StrtoFloat(Form1.WebEdit21.Text)*StrtoFloat(Form1.WebEdit31.Text));
   Form1.WebEdit42.Text:=FloattoStr(StrtoFloat(Form1.WebEdit12.Text)*StrtoFloat(Form1.WebEdit22.Text)*StrtoFloat(Form1.WebEdit32.Text));

   Form1.WebEdit43.Text:=FloattoStr(StrtoFloat(Form1.WebEdit13.Text)+StrtoFloat(Form1.WebEdit14.Text)+StrtoFloat(Form1.WebEdit15.Text)+StrtoFloat(Form1.WebEdit16.Text)+StrtoFloat(Form1.WebEdit17.Text)+StrtoFloat(Form1.WebEdit18.Text)+StrtoFloat(Form1.WebEdit19.Text)+StrtoFloat(Form1.WebEdit20.Text)+StrtoFloat(Form1.WebEdit21.Text)+StrtoFloat(Form1.WebEdit22.Text));
   Form1.WebEdit44.Text:=FloattoStr(StrtoFloat(Form1.WebEdit3.Text)+StrtoFloat(Form1.WebEdit4.Text)+StrtoFloat(Form1.WebEdit5.Text)+StrtoFloat(Form1.WebEdit6.Text)+StrtoFloat(Form1.WebEdit7.Text)+StrtoFloat(Form1.WebEdit8.Text)+StrtoFloat(Form1.WebEdit9.Text)+StrtoFloat(Form1.WebEdit10.Text)+StrtoFloat(Form1.WebEdit11.Text)+StrtoFloat(Form1.WebEdit12.Text));
   Form1.WebEdit45.Text:=FloattoStr(StrtoFloat(Form1.WebEdit23.Text)+StrtoFloat(Form1.WebEdit24.Text)+StrtoFloat(Form1.WebEdit25.Text)+StrtoFloat(Form1.WebEdit26.Text)+StrtoFloat(Form1.WebEdit27.Text)+StrtoFloat(Form1.WebEdit28.Text)+StrtoFloat(Form1.WebEdit29.Text)+StrtoFloat(Form1.WebEdit30.Text)+StrtoFloat(Form1.WebEdit31.Text)+StrtoFloat(Form1.WebEdit32.Text));
   Form1.WebEdit46.Text:=FloattoStr(StrtoFloat(Form1.WebEdit33.Text)+StrtoFloat(Form1.WebEdit34.Text)+StrtoFloat(Form1.WebEdit35.Text)+StrtoFloat(Form1.WebEdit36.Text)+StrtoFloat(Form1.WebEdit37.Text)+StrtoFloat(Form1.WebEdit38.Text)+StrtoFloat(Form1.WebEdit39.Text)+StrtoFloat(Form1.WebEdit40.Text)+StrtoFloat(Form1.WebEdit41.Text)+StrtoFloat(Form1.WebEdit42.Text));

   Form1.WebEdit2.Text:=Form1.WebEdit46.Text;
   Ka:=StrtoFloat(Form1.WebEdit2.Text)*StrtoFloat(Form1.WebComboBox1.Text)*2/StrtoFloat(Form1.WebComboBox3.Text);
   Form1.WebEdit47.Text:=FloattoStr(SimpleRoundTo (Ka * 100, 0) / 100);
   Form1.WebLabel17.Caption:='Q = '+Form1.WebEdit47.Text+' Ah';
   Ka:=StrtoFloat(Form1.WebEdit2.Text)/ST*StrtoFloat(Form1.WebComboBox1.Text);
   Form1.WebEdit48.Text:=FloattoStr(SimpleRoundTo (Ka * 100, 0) / 100);
   Ka:=Na*1.6;
   Form1.WebEdit49.Text:=FloattoStr(SimpleRoundTo (Ka * 100, 0) / 100);
   Form1.WebLabel12.Caption:='t = '+Form1.WebEdit49.Text+' godz';
   Ka:=StrtoFloat(Form1.WebEdit46.Text)/(Na*1.6)/ST;
   Form1.WebEdit51.Text:=FloattoStr(SimpleRoundTo (Ka * 100, 0) / 100);
   Form1.WebLabel37.Caption:='P = '+Form1.WebEdit51.Text+' Wp';
   Ka:=StrtoFloat(Form1.WebComboBox5.Text)*0.0175*StrtoFloat(Form1.WebEdit51.Text)/0.03/StrtoFloat(Form1.WebComboBox3.Text)/StrtoFloat(Form1.WebComboBox3.Text);
   Form1.WebEdit1.Text:=FloattoStr(SimpleRoundTo (Ka * 100, 0) / 100);
   Form1.WebLabel16.Caption:='L = L1 + L2 = '+Form1.WebComboBox5.Text+' m';
end;

procedure TForm1.WebComboBox1Change(Sender: TObject);
begin

  SUMA;

end;

procedure TForm1.WebComboBox2Change(Sender: TObject);
begin

 SUMA;

 end;


procedure TForm1.WebComboBox3Change(Sender: TObject);
begin

 SUMA;

 end;

procedure TForm1.WebComboBox4Change(Sender: TObject);
begin

 SUMA;

 end;

procedure TForm1.WebComboBox5Change(Sender: TObject);
begin

 SUMA;

end;

procedure TForm1.WebEdit10KeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
   Val(WebEdit10.Text, nett, code);
   if code = 0 then begin

    SUMA;

   end else WebEdit10.Text := ''
end;

procedure TForm1.WebEdit11KeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
   Val(WebEdit11.Text, nett, code);
   if code = 0 then begin

    SUMA;

   end else WebEdit11.Text := ''
end;

procedure TForm1.WebEdit12KeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
   Val(WebEdit12.Text, nett, code);
   if code = 0 then begin

    SUMA;

   end else WebEdit12.Text := ''
end;

procedure TForm1.WebEdit13KeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
  begin
  if WebEdit13.Text='' then Exit;
   Val(WebEdit13.Text, nett, code);
   if code = 0 then begin
    SUMA;
   end else WebEdit13.Text := ''
end;


procedure TForm1.WebEdit14KeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  if WebEdit14.Text='' then Exit;
   Val(WebEdit14.Text, nett, code);
   if code = 0 then begin

    SUMA;

   end else WebEdit14.Text := ''
end;

procedure TForm1.WebEdit15KeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  if WebEdit15.Text='' then Exit;
   Val(WebEdit15.Text, nett, code);
   if code = 0 then begin

    SUMA;

   end else WebEdit15.Text := ''
end;

procedure TForm1.WebEdit16KeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  if WebEdit16.Text='' then Exit;
   Val(WebEdit16.Text, nett, code);
   if code = 0 then begin

    SUMA;

   end else WebEdit16.Text := ''
end;

procedure TForm1.WebEdit17KeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  if WebEdit17.Text='' then Exit;
   Val(WebEdit17.Text, nett, code);
   if code = 0 then begin

    SUMA;

   end else WebEdit17.Text := ''
end;

procedure TForm1.WebEdit18KeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  if WebEdit18.Text='' then Exit;
   Val(WebEdit18.Text, nett, code);
   if code = 0 then begin

    SUMA;

   end else WebEdit18.Text := ''
end;

procedure TForm1.WebEdit19KeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  if WebEdit19.Text='' then Exit;
   Val(WebEdit19.Text, nett, code);
   if code = 0 then begin

    SUMA;

   end else WebEdit19.Text := ''
end;

procedure TForm1.WebEdit20KeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  if WebEdit20.Text='' then Exit;
   Val(WebEdit20.Text, nett, code);
   if code = 0 then begin

    SUMA;

   end else WebEdit20.Text := ''
end;

procedure TForm1.WebEdit21KeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  if WebEdit21.Text='' then Exit;
   Val(WebEdit21.Text, nett, code);
   if code = 0 then begin

    SUMA;

   end else WebEdit21.Text := ''
end;

procedure TForm1.WebEdit22KeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  if WebEdit22.Text='' then Exit;
   Val(WebEdit22.Text, nett, code);
   if code = 0 then begin

    SUMA;

   end else WebEdit22.Text := ''
end;

procedure TForm1.WebEdit23KeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  if WebEdit23.Text='' then Exit;
   Val(WebEdit23.Text, nett, code);
   if code = 0 then begin

    SUMA;

   end else WebEdit23.Text := ''
end;

procedure TForm1.WebEdit24KeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  if WebEdit24.Text='' then Exit;
   Val(WebEdit24.Text, nett, code);
   if code = 0 then begin

    SUMA;

   end else WebEdit24.Text := ''
end;

procedure TForm1.WebEdit25KeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  if WebEdit25.Text='' then Exit;
   Val(WebEdit25.Text, nett, code);
   if code = 0 then begin

    SUMA;

   end else WebEdit25.Text := ''
end;

procedure TForm1.WebEdit26KeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  if WebEdit26.Text='' then Exit;
   Val(WebEdit26.Text, nett, code);
   if code = 0 then begin

    SUMA;

   end else WebEdit26.Text := ''
end;

procedure TForm1.WebEdit27KeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  if WebEdit27.Text='' then Exit;
   Val(WebEdit27.Text, nett, code);
   if code = 0 then begin

    SUMA;

   end else WebEdit27.Text := ''
end;

procedure TForm1.WebEdit28KeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  if WebEdit28.Text='' then Exit;
   Val(WebEdit28.Text, nett, code);
   if code = 0 then begin

    SUMA;

   end else WebEdit28.Text := ''
end;

procedure TForm1.WebEdit29KeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  if WebEdit29.Text='' then Exit;
   Val(WebEdit29.Text, nett, code);
   if code = 0 then begin

    SUMA;

   end else WebEdit29.Text := ''
end;

procedure TForm1.WebEdit30KeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  if WebEdit30.Text='' then Exit;
   Val(WebEdit30.Text, nett, code);
   if code = 0 then begin

    SUMA;

   end else WebEdit30.Text := ''
end;

procedure TForm1.WebEdit31KeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  if WebEdit31.Text='' then Exit;
   Val(WebEdit31.Text, nett, code);
   if code = 0 then begin

    SUMA;

   end else WebEdit31.Text := ''
end;

procedure TForm1.WebEdit32KeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  if WebEdit32.Text='' then Exit;
   Val(WebEdit32.Text, nett, code);
   if code = 0 then begin

    SUMA;

   end else WebEdit32.Text := ''
end;

procedure TForm1.WebEdit33KeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  if WebEdit33.Text='' then Exit;
   Val(WebEdit33.Text, nett, code);
   if code = 0 then begin

    SUMA;

   end else WebEdit33.Text := ''
end;

procedure TForm1.WebEdit34KeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  if WebEdit34.Text='' then Exit;
   Val(WebEdit34.Text, nett, code);
   if code = 0 then begin

    SUMA;

   end else WebEdit34.Text := ''
end;

procedure TForm1.WebEdit35KeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  if WebEdit35.Text='' then Exit;
   Val(WebEdit35.Text, nett, code);
   if code = 0 then begin

    SUMA;

   end else WebEdit35.Text := ''
end;

procedure TForm1.WebEdit36KeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  if WebEdit36.Text='' then Exit;
   Val(WebEdit36.Text, nett, code);
   if code = 0 then begin

    SUMA;

   end else WebEdit36.Text := ''
end;

procedure TForm1.WebEdit37KeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  if WebEdit37.Text='' then Exit;
   Val(WebEdit37.Text, nett, code);
   if code = 0 then begin

    SUMA;

   end else WebEdit37.Text := ''
end;

procedure TForm1.WebEdit38KeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  if WebEdit38.Text='' then Exit;
   Val(WebEdit38.Text, nett, code);
   if code = 0 then begin

    SUMA;

   end else WebEdit38.Text := ''
end;

procedure TForm1.WebEdit39KeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  if WebEdit39.Text='' then Exit;
   Val(WebEdit39.Text, nett, code);
   if code = 0 then begin

    SUMA;

   end else WebEdit39.Text := ''
end;

procedure TForm1.WebEdit3KeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  if WebEdit3.Text='' then Exit;
   Val(WebEdit3.Text, nett, code);
   if code = 0 then begin

    SUMA;

   end else WebEdit3.Text := ''
end;

procedure TForm1.WebEdit40KeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  if WebEdit40.Text='' then Exit;
   Val(WebEdit40.Text, nett, code);
   if code = 0 then begin

    SUMA;

   end else WebEdit40.Text := ''
end;

procedure TForm1.WebEdit41KeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  if WebEdit41.Text='' then Exit;
   Val(WebEdit41.Text, nett, code);
   if code = 0 then begin

    SUMA;

   end else WebEdit41.Text := ''
end;

procedure TForm1.WebEdit42KeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  if WebEdit42.Text='' then Exit;
   Val(WebEdit42.Text, nett, code);
   if code = 0 then begin

    SUMA;

   end else WebEdit42.Text := ''
end;

procedure TForm1.WebEdit4KeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  if WebEdit4.Text='' then Exit;
   Val(WebEdit4.Text, nett, code);
   if code = 0 then begin

    SUMA;

   end else WebEdit4.Text := ''
end;

procedure TForm1.WebEdit5KeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  if WebEdit5.Text='' then Exit;
   Val(WebEdit5.Text, nett, code);
   if code = 0 then begin

    SUMA;

   end else WebEdit5.Text := ''
end;

procedure TForm1.WebEdit6KeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  if WebEdit6.Text='' then Exit;
   Val(WebEdit6.Text, nett, code);
   if code = 0 then begin

    SUMA;

   end else WebEdit6.Text := ''
end;

procedure TForm1.WebEdit7KeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  if WebEdit7.Text='' then Exit;
   Val(WebEdit7.Text, nett, code);
   if code = 0 then begin

    SUMA;

   end else WebEdit7.Text := ''
end;

procedure TForm1.WebEdit8KeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  if WebEdit8.Text='' then Exit;
   Val(WebEdit8.Text, nett, code);
   if code = 0 then begin

    SUMA;

   end else WebEdit8.Text := ''
end;

procedure TForm1.WebEdit9KeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  if WebEdit9.Text='' then Exit;
   Val(WebEdit9.Text, nett, code);
   if code = 0 then begin

    SUMA;

   end else WebEdit9.Text := ''
end;

procedure TForm1.WebRadioButton1Click(Sender: TObject);
var  PI, V1, V2, V3, ka1, ka2, Od, y, tot, L, ka3         : Real;
     Lc, Sw                                               : String;
     l1, l2                                               : Integer;
begin
PI:=3.1415926536;
case WebComboBox1.ItemIndex of
0: ka3:=Wysokosc[0];
1: ka3:=Wysokosc[1];
2: ka3:=Wysokosc[2];
3: ka3:=Wysokosc[3];
4: ka3:=Wysokosc[4];
5: ka3:=Wysokosc[5];
6: ka3:=Wysokosc[6];
7: ka3:=Wysokosc[7];
8: ka3:=Wysokosc[8];
9: ka3:=Wysokosc[9];
10: ka3:=Wysokosc[10];
11: ka3:=Wysokosc[11];
12: ka3:=Wysokosc[12];
13: ka3:=Wysokosc[13];
14: ka3:=Wysokosc[14];
15: ka3:=Wysokosc[15];
16: ka3:=Wysokosc[16];
17: ka3:=Wysokosc[17];
18: ka3:=Wysokosc[18];
19: ka3:=Wysokosc[19];
20: ka3:=Wysokosc[20];
21: ka3:=Wysokosc[21];
22: ka3:=Wysokosc[22];
23: ka3:=Wysokosc[23];
end;
ka1:=StrtoFloat(WebComboBox3.Text)*PI/180;
ka2:=ka3*PI/180;
V1:=Sin(ka1);
V2:=Sin(ka2);
V3:=Cos(ka2);
V3:=V2/V3;
y:=Cos(ka1)*L/1000;
Od:=V1*L/V3/1000;
 tot:=y+Od;
 WebEdit2.Text:=FloattoStr(SimpleRoundTo (Od * 100, 0) / 100);
 WebEdit3.Text:=FloattoStr(SimpleRoundTo (tot * 100, 0) / 100);

 WebLabel15.Caption:='L = '+FloattoStr(SimpleRoundTo (Od * 100, 0) / 100)+' m';
 WebLabel11.Caption:='O = '+FloattoStr(SimpleRoundTo (tot * 100, 0) / 100)+' m';
 WebLabel16.Caption:='< '+WebComboBox3.Text;
 WebLabel17.Caption:='< '+FloattoStr(SimpleRoundTo (ka3 * 100, 0) / 100);
 WebLabel12.Caption:='M = '+FloattoStr(SimpleRoundTo (L/1000 * 100, 0) / 100)+' m';
 end;

procedure TForm1.WebRadioButton2Click(Sender: TObject);
var  PI, V1, V2, V3, ka1, ka2, Od, y, tot, L, ka3         : Real;
     Lc, Sw                                               : String;
     l1, l2                                               : Integer;
begin
PI:=3.1415926536;
case WebComboBox1.ItemIndex of
0: ka3:=Wysokosc[0];
1: ka3:=Wysokosc[1];
2: ka3:=Wysokosc[2];
3: ka3:=Wysokosc[3];
4: ka3:=Wysokosc[4];
5: ka3:=Wysokosc[5];
6: ka3:=Wysokosc[6];
7: ka3:=Wysokosc[7];
8: ka3:=Wysokosc[8];
9: ka3:=Wysokosc[9];
10: ka3:=Wysokosc[10];
11: ka3:=Wysokosc[11];
12: ka3:=Wysokosc[12];
13: ka3:=Wysokosc[13];
14: ka3:=Wysokosc[14];
15: ka3:=Wysokosc[15];
16: ka3:=Wysokosc[16];
17: ka3:=Wysokosc[17];
18: ka3:=Wysokosc[18];
19: ka3:=Wysokosc[19];
20: ka3:=Wysokosc[20];
21: ka3:=Wysokosc[21];
22: ka3:=Wysokosc[22];
23: ka3:=Wysokosc[23];
end;
ka1:=StrtoFloat(WebComboBox3.Text)*PI/180;
ka2:=ka3*PI/180;
V1:=Sin(ka1);
V2:=Sin(ka2);
V3:=Cos(ka2);
V3:=V2/V3;
y:=Cos(ka1)*L/1000;
Od:=V1*L/V3/1000;
 tot:=y+Od;
 WebEdit2.Text:=FloattoStr(SimpleRoundTo (Od * 100, 0) / 100);
 WebEdit3.Text:=FloattoStr(SimpleRoundTo (tot * 100, 0) / 100);

 WebLabel15.Caption:='L = '+FloattoStr(SimpleRoundTo (Od * 100, 0) / 100)+' m';
 WebLabel11.Caption:='O = '+FloattoStr(SimpleRoundTo (tot * 100, 0) / 100)+' m';
 WebLabel16.Caption:='< '+WebComboBox3.Text;
 WebLabel17.Caption:='< '+FloattoStr(SimpleRoundTo (ka3 * 100, 0) / 100);
 WebLabel12.Caption:='M = '+FloattoStr(SimpleRoundTo (L/1000 * 100, 0) / 100)+' m';
 end;

procedure TForm1.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebLabel1 := TLabel.Create(Self);
  WebImageControl1 := TImageControl.Create(Self);
  WebLabel11 := TLabel.Create(Self);
  WebLabel15 := TLabel.Create(Self);
  WebLabel12 := TLabel.Create(Self);
  WebLabel17 := TLabel.Create(Self);
  WebImageControl2 := TImageControl.Create(Self);
  WebLabel18 := TLabel.Create(Self);
  WebLabel16 := TLabel.Create(Self);
  WebLabel37 := TLabel.Create(Self);
  WebGroupBox1 := TGroupBox.Create(Self);
  WebLabel19 := TLabel.Create(Self);
  WebLabel20 := TLabel.Create(Self);
  WebLabel21 := TLabel.Create(Self);
  WebLabel22 := TLabel.Create(Self);
  WebLabel23 := TLabel.Create(Self);
  WebLabel24 := TLabel.Create(Self);
  WebLabel25 := TLabel.Create(Self);
  WebLabel26 := TLabel.Create(Self);
  WebLabel27 := TLabel.Create(Self);
  WebLabel28 := TLabel.Create(Self);
  WebLabel29 := TLabel.Create(Self);
  WebLabel80 := TLabel.Create(Self);
  WebLabel81 := TLabel.Create(Self);
  WebLabel82 := TLabel.Create(Self);
  WebLabel83 := TLabel.Create(Self);
  WebEdit4 := TEdit.Create(Self);
  WebEdit5 := TEdit.Create(Self);
  WebEdit6 := TEdit.Create(Self);
  WebEdit7 := TEdit.Create(Self);
  WebEdit8 := TEdit.Create(Self);
  WebEdit9 := TEdit.Create(Self);
  WebEdit10 := TEdit.Create(Self);
  WebEdit11 := TEdit.Create(Self);
  WebEdit12 := TEdit.Create(Self);
  WebEdit13 := TEdit.Create(Self);
  WebEdit14 := TEdit.Create(Self);
  WebEdit15 := TEdit.Create(Self);
  WebEdit16 := TEdit.Create(Self);
  WebEdit17 := TEdit.Create(Self);
  WebEdit18 := TEdit.Create(Self);
  WebEdit19 := TEdit.Create(Self);
  WebEdit20 := TEdit.Create(Self);
  WebEdit21 := TEdit.Create(Self);
  WebEdit22 := TEdit.Create(Self);
  WebEdit23 := TEdit.Create(Self);
  WebEdit24 := TEdit.Create(Self);
  WebEdit25 := TEdit.Create(Self);
  WebEdit26 := TEdit.Create(Self);
  WebEdit27 := TEdit.Create(Self);
  WebEdit28 := TEdit.Create(Self);
  WebEdit29 := TEdit.Create(Self);
  WebEdit30 := TEdit.Create(Self);
  WebEdit31 := TEdit.Create(Self);
  WebEdit32 := TEdit.Create(Self);
  WebEdit33 := TEdit.Create(Self);
  WebEdit34 := TEdit.Create(Self);
  WebEdit35 := TEdit.Create(Self);
  WebEdit36 := TEdit.Create(Self);
  WebEdit37 := TEdit.Create(Self);
  WebEdit38 := TEdit.Create(Self);
  WebEdit39 := TEdit.Create(Self);
  WebEdit40 := TEdit.Create(Self);
  WebEdit41 := TEdit.Create(Self);
  WebEdit42 := TEdit.Create(Self);
  WebEdit43 := TEdit.Create(Self);
  WebEdit44 := TEdit.Create(Self);
  WebEdit45 := TEdit.Create(Self);
  WebEdit46 := TEdit.Create(Self);
  WebEdit3 := TEdit.Create(Self);
  WebGroupBox2 := TGroupBox.Create(Self);
  WebLabel2 := TLabel.Create(Self);
  WebLabel3 := TLabel.Create(Self);
  WebLabel14 := TLabel.Create(Self);
  WebLabel4 := TLabel.Create(Self);
  WebLabel6 := TLabel.Create(Self);
  WebLabel5 := TLabel.Create(Self);
  WebLabel9 := TLabel.Create(Self);
  WebLabel36 := TLabel.Create(Self);
  WebComboBox3 := TComboBox.Create(Self);
  WebComboBox1 := TComboBox.Create(Self);
  WebComboBox2 := TComboBox.Create(Self);
  WebComboBox4 := TComboBox.Create(Self);
  WebComboBox5 := TComboBox.Create(Self);
  WebGroupBox3 := TGroupBox.Create(Self);
  WebLabel30 := TLabel.Create(Self);
  WebLabel31 := TLabel.Create(Self);
  WebLabel32 := TLabel.Create(Self);
  WebLabel33 := TLabel.Create(Self);
  WebLabel34 := TLabel.Create(Self);
  WebLabel35 := TLabel.Create(Self);
  WebLabel38 := TLabel.Create(Self);
  WebLabel39 := TLabel.Create(Self);
  WebLabel7 := TLabel.Create(Self);
  WebLabel8 := TLabel.Create(Self);
  WebLabel10 := TLabel.Create(Self);
  WebLabel13 := TLabel.Create(Self);
  WebEdit2 := TEdit.Create(Self);
  WebEdit47 := TEdit.Create(Self);
  WebEdit48 := TEdit.Create(Self);
  WebEdit49 := TEdit.Create(Self);
  WebEdit51 := TEdit.Create(Self);
  WebEdit1 := TEdit.Create(Self);

  WebLabel1.BeforeLoadDFMValues;
  WebImageControl1.BeforeLoadDFMValues;
  WebLabel11.BeforeLoadDFMValues;
  WebLabel15.BeforeLoadDFMValues;
  WebLabel12.BeforeLoadDFMValues;
  WebLabel17.BeforeLoadDFMValues;
  WebImageControl2.BeforeLoadDFMValues;
  WebLabel18.BeforeLoadDFMValues;
  WebLabel16.BeforeLoadDFMValues;
  WebLabel37.BeforeLoadDFMValues;
  WebGroupBox1.BeforeLoadDFMValues;
  WebLabel19.BeforeLoadDFMValues;
  WebLabel20.BeforeLoadDFMValues;
  WebLabel21.BeforeLoadDFMValues;
  WebLabel22.BeforeLoadDFMValues;
  WebLabel23.BeforeLoadDFMValues;
  WebLabel24.BeforeLoadDFMValues;
  WebLabel25.BeforeLoadDFMValues;
  WebLabel26.BeforeLoadDFMValues;
  WebLabel27.BeforeLoadDFMValues;
  WebLabel28.BeforeLoadDFMValues;
  WebLabel29.BeforeLoadDFMValues;
  WebLabel80.BeforeLoadDFMValues;
  WebLabel81.BeforeLoadDFMValues;
  WebLabel82.BeforeLoadDFMValues;
  WebLabel83.BeforeLoadDFMValues;
  WebEdit4.BeforeLoadDFMValues;
  WebEdit5.BeforeLoadDFMValues;
  WebEdit6.BeforeLoadDFMValues;
  WebEdit7.BeforeLoadDFMValues;
  WebEdit8.BeforeLoadDFMValues;
  WebEdit9.BeforeLoadDFMValues;
  WebEdit10.BeforeLoadDFMValues;
  WebEdit11.BeforeLoadDFMValues;
  WebEdit12.BeforeLoadDFMValues;
  WebEdit13.BeforeLoadDFMValues;
  WebEdit14.BeforeLoadDFMValues;
  WebEdit15.BeforeLoadDFMValues;
  WebEdit16.BeforeLoadDFMValues;
  WebEdit17.BeforeLoadDFMValues;
  WebEdit18.BeforeLoadDFMValues;
  WebEdit19.BeforeLoadDFMValues;
  WebEdit20.BeforeLoadDFMValues;
  WebEdit21.BeforeLoadDFMValues;
  WebEdit22.BeforeLoadDFMValues;
  WebEdit23.BeforeLoadDFMValues;
  WebEdit24.BeforeLoadDFMValues;
  WebEdit25.BeforeLoadDFMValues;
  WebEdit26.BeforeLoadDFMValues;
  WebEdit27.BeforeLoadDFMValues;
  WebEdit28.BeforeLoadDFMValues;
  WebEdit29.BeforeLoadDFMValues;
  WebEdit30.BeforeLoadDFMValues;
  WebEdit31.BeforeLoadDFMValues;
  WebEdit32.BeforeLoadDFMValues;
  WebEdit33.BeforeLoadDFMValues;
  WebEdit34.BeforeLoadDFMValues;
  WebEdit35.BeforeLoadDFMValues;
  WebEdit36.BeforeLoadDFMValues;
  WebEdit37.BeforeLoadDFMValues;
  WebEdit38.BeforeLoadDFMValues;
  WebEdit39.BeforeLoadDFMValues;
  WebEdit40.BeforeLoadDFMValues;
  WebEdit41.BeforeLoadDFMValues;
  WebEdit42.BeforeLoadDFMValues;
  WebEdit43.BeforeLoadDFMValues;
  WebEdit44.BeforeLoadDFMValues;
  WebEdit45.BeforeLoadDFMValues;
  WebEdit46.BeforeLoadDFMValues;
  WebEdit3.BeforeLoadDFMValues;
  WebGroupBox2.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  WebLabel3.BeforeLoadDFMValues;
  WebLabel14.BeforeLoadDFMValues;
  WebLabel4.BeforeLoadDFMValues;
  WebLabel6.BeforeLoadDFMValues;
  WebLabel5.BeforeLoadDFMValues;
  WebLabel9.BeforeLoadDFMValues;
  WebLabel36.BeforeLoadDFMValues;
  WebComboBox3.BeforeLoadDFMValues;
  WebComboBox1.BeforeLoadDFMValues;
  WebComboBox2.BeforeLoadDFMValues;
  WebComboBox4.BeforeLoadDFMValues;
  WebComboBox5.BeforeLoadDFMValues;
  WebGroupBox3.BeforeLoadDFMValues;
  WebLabel30.BeforeLoadDFMValues;
  WebLabel31.BeforeLoadDFMValues;
  WebLabel32.BeforeLoadDFMValues;
  WebLabel33.BeforeLoadDFMValues;
  WebLabel34.BeforeLoadDFMValues;
  WebLabel35.BeforeLoadDFMValues;
  WebLabel38.BeforeLoadDFMValues;
  WebLabel39.BeforeLoadDFMValues;
  WebLabel7.BeforeLoadDFMValues;
  WebLabel8.BeforeLoadDFMValues;
  WebLabel10.BeforeLoadDFMValues;
  WebLabel13.BeforeLoadDFMValues;
  WebEdit2.BeforeLoadDFMValues;
  WebEdit47.BeforeLoadDFMValues;
  WebEdit48.BeforeLoadDFMValues;
  WebEdit49.BeforeLoadDFMValues;
  WebEdit51.BeforeLoadDFMValues;
  WebEdit1.BeforeLoadDFMValues;
  try
    Name := 'Form1';
    Left := 0;
    Top := 0;
    Width := 956;
    Height := 784;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := 14;
    Font.Name := 'Tahoma';
    Font.Style := [];
    TabOrder := 1;
    WebLabel1.SetParentComponent(Self);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 13;
    WebLabel1.Top := 150;
    WebLabel1.Width := 170;
    WebLabel1.Height := 14;
    WebLabel1.Caption := 'Kalkulator instalacji off-grid';
    WebLabel1.Font.Charset := DEFAULT_CHARSET;
    WebLabel1.Font.Color := clHotLight;
    WebLabel1.Font.Height := 14;
    WebLabel1.Font.Name := 'Tahoma';
    WebLabel1.Font.Style := [fsBold];
    WebLabel1.ParentFont := False;
    WebLabel1.Transparent := False;
    WebImageControl1.SetParentComponent(Self);
    WebImageControl1.Name := 'WebImageControl1';
    WebImageControl1.Left := 0;
    WebImageControl1.Top := 170;
    WebImageControl1.Width := 913;
    WebImageControl1.Height := 287;
    WebImageControl1.ChildOrder := 1;
    WebImageControl1.Picture.LoadFromFile('Offgrids.WebImageControl1.Picture.jpg');
    WebLabel11.SetParentComponent(Self);
    WebLabel11.Name := 'WebLabel11';
    WebLabel11.Left := 239;
    WebLabel11.Top := 392;
    WebLabel11.Width := 9;
    WebLabel11.Height := 11;
    WebLabel11.Caption := 'L1';
    WebLabel11.Font.Charset := DEFAULT_CHARSET;
    WebLabel11.Font.Color := clBlue;
    WebLabel11.Font.Height := 11;
    WebLabel11.Font.Name := 'Tahoma';
    WebLabel11.Font.Style := [];
    WebLabel11.ParentFont := False;
    WebLabel15.SetParentComponent(Self);
    WebLabel15.Name := 'WebLabel15';
    WebLabel15.Left := 517;
    WebLabel15.Top := 392;
    WebLabel15.Width := 9;
    WebLabel15.Height := 11;
    WebLabel15.Caption := 'L2';
    WebLabel15.Font.Charset := DEFAULT_CHARSET;
    WebLabel15.Font.Color := clBlue;
    WebLabel15.Font.Height := 11;
    WebLabel15.Font.Name := 'Tahoma';
    WebLabel15.Font.Style := [];
    WebLabel15.ParentFont := False;
    WebLabel12.SetParentComponent(Self);
    WebLabel12.Name := 'WebLabel12';
    WebLabel12.Left := 414;
    WebLabel12.Top := 197;
    WebLabel12.Width := 63;
    WebLabel12.Height := 14;
    WebLabel12.Caption := 't = 0 godz.';
    WebLabel12.Font.Charset := DEFAULT_CHARSET;
    WebLabel12.Font.Color := clBlue;
    WebLabel12.Font.Height := 14;
    WebLabel12.Font.Name := 'Tahoma';
    WebLabel12.Font.Style := [];
    WebLabel12.ParentFont := False;
    WebLabel12.Transparent := False;
    WebLabel17.SetParentComponent(Self);
    WebLabel17.Name := 'WebLabel17';
    WebLabel17.Left := 770;
    WebLabel17.Top := 400;
    WebLabel17.Width := 52;
    WebLabel17.Height := 14;
    WebLabel17.Caption := 'Q = 0 Ah';
    WebLabel17.Font.Charset := DEFAULT_CHARSET;
    WebLabel17.Font.Color := clBlue;
    WebLabel17.Font.Height := 14;
    WebLabel17.Font.Name := 'Tahoma';
    WebLabel17.Font.Style := [];
    WebLabel17.ParentFont := False;
    WebImageControl2.SetParentComponent(Self);
    WebImageControl2.Name := 'WebImageControl2';
    WebImageControl2.Left := 0;
    WebImageControl2.Top := 8;
    WebImageControl2.Width := 289;
    WebImageControl2.Height := 121;
    WebImageControl2.ChildOrder := 12;
    WebImageControl2.Picture.LoadFromFile('Offgrids.WebImageControl2.Picture.png');
    WebLabel18.SetParentComponent(Self);
    WebLabel18.Name := 'WebLabel18';
    WebLabel18.Left := 3;
    WebLabel18.Top := 757;
    WebLabel18.Width := 151;
    WebLabel18.Height := 14;
    WebLabel18.Caption := 'Pro-Sun (c) Copyright 2020';
    WebLabel18.Color := clYellow;
    WebLabel18.Transparent := False;
    WebLabel16.SetParentComponent(Self);
    WebLabel16.Name := 'WebLabel16';
    WebLabel16.Left := 336;
    WebLabel16.Top := 432;
    WebLabel16.Width := 106;
    WebLabel16.Height := 14;
    WebLabel16.Caption := 'L= L1 + L2 = 10 m';
    WebLabel16.Font.Charset := DEFAULT_CHARSET;
    WebLabel16.Font.Color := clBlue;
    WebLabel16.Font.Height := 14;
    WebLabel16.Font.Name := 'Tahoma';
    WebLabel16.Font.Style := [];
    WebLabel16.ParentFont := False;
    WebLabel37.SetParentComponent(Self);
    WebLabel37.Name := 'WebLabel37';
    WebLabel37.Left := 239;
    WebLabel37.Top := 336;
    WebLabel37.Width := 60;
    WebLabel37.Height := 14;
    WebLabel37.Caption := 'P = 0 kWp';
    WebLabel37.Font.Charset := DEFAULT_CHARSET;
    WebLabel37.Font.Color := clBlue;
    WebLabel37.Font.Height := 14;
    WebLabel37.Font.Name := 'Tahoma';
    WebLabel37.Font.Style := [];
    WebLabel37.ParentFont := False;
    WebGroupBox1.SetParentComponent(Self);
    WebGroupBox1.Name := 'WebGroupBox1';
    WebGroupBox1.Left := 0;
    WebGroupBox1.Top := 463;
    WebGroupBox1.Width := 499;
    WebGroupBox1.Height := 288;
    WebGroupBox1.Caption := 'Dzienny pob'#243'r energii odbiornik'#243'w z instalacji off-grid ';
    WebGroupBox1.ChildOrder := 2;
    WebGroupBox1.Color := clWhite;
    WebGroupBox1.Font.Charset := DEFAULT_CHARSET;
    WebGroupBox1.Font.Color := clWindowText;
    WebGroupBox1.Font.Height := 11;
    WebGroupBox1.Font.Name := 'Tahoma';
    WebGroupBox1.Font.Style := [];
    WebGroupBox1.ParentFont := False;
    WebLabel19.SetParentComponent(WebGroupBox1);
    WebLabel19.Name := 'WebLabel19';
    WebLabel19.Left := 16;
    WebLabel19.Top := 43;
    WebLabel19.Width := 59;
    WebLabel19.Height := 11;
    WebLabel19.Caption := 'Odbiornik nr 1';
    WebLabel20.SetParentComponent(WebGroupBox1);
    WebLabel20.Name := 'WebLabel20';
    WebLabel20.Left := 16;
    WebLabel20.Top := 64;
    WebLabel20.Width := 59;
    WebLabel20.Height := 11;
    WebLabel20.Caption := 'Odbiornik nr 2';
    WebLabel21.SetParentComponent(WebGroupBox1);
    WebLabel21.Name := 'WebLabel21';
    WebLabel21.Left := 16;
    WebLabel21.Top := 85;
    WebLabel21.Width := 59;
    WebLabel21.Height := 11;
    WebLabel21.Caption := 'Odbiornik nr 3';
    WebLabel22.SetParentComponent(WebGroupBox1);
    WebLabel22.Name := 'WebLabel22';
    WebLabel22.Left := 16;
    WebLabel22.Top := 106;
    WebLabel22.Width := 59;
    WebLabel22.Height := 11;
    WebLabel22.Caption := 'Odbiornik nr 4';
    WebLabel23.SetParentComponent(WebGroupBox1);
    WebLabel23.Name := 'WebLabel23';
    WebLabel23.Left := 16;
    WebLabel23.Top := 127;
    WebLabel23.Width := 59;
    WebLabel23.Height := 11;
    WebLabel23.Caption := 'Odbiornik nr 5';
    WebLabel24.SetParentComponent(WebGroupBox1);
    WebLabel24.Name := 'WebLabel24';
    WebLabel24.Left := 16;
    WebLabel24.Top := 148;
    WebLabel24.Width := 59;
    WebLabel24.Height := 11;
    WebLabel24.Caption := 'Odbiornik nr 6';
    WebLabel25.SetParentComponent(WebGroupBox1);
    WebLabel25.Name := 'WebLabel25';
    WebLabel25.Left := 16;
    WebLabel25.Top := 169;
    WebLabel25.Width := 59;
    WebLabel25.Height := 11;
    WebLabel25.Caption := 'Odbiornik nr 7';
    WebLabel26.SetParentComponent(WebGroupBox1);
    WebLabel26.Name := 'WebLabel26';
    WebLabel26.Left := 16;
    WebLabel26.Top := 190;
    WebLabel26.Width := 59;
    WebLabel26.Height := 11;
    WebLabel26.Caption := 'Odbiornik nr 8';
    WebLabel27.SetParentComponent(WebGroupBox1);
    WebLabel27.Name := 'WebLabel27';
    WebLabel27.Left := 16;
    WebLabel27.Top := 211;
    WebLabel27.Width := 59;
    WebLabel27.Height := 11;
    WebLabel27.Caption := 'Odbiornik nr 9';
    WebLabel28.SetParentComponent(WebGroupBox1);
    WebLabel28.Name := 'WebLabel28';
    WebLabel28.Left := 16;
    WebLabel28.Top := 232;
    WebLabel28.Width := 64;
    WebLabel28.Height := 11;
    WebLabel28.Caption := 'Odbiornik nr 10';
    WebLabel29.SetParentComponent(WebGroupBox1);
    WebLabel29.Name := 'WebLabel29';
    WebLabel29.Left := 53;
    WebLabel29.Top := 260;
    WebLabel29.Width := 28;
    WebLabel29.Height := 11;
    WebLabel29.Caption := 'Razem';
    WebLabel29.Font.Charset := DEFAULT_CHARSET;
    WebLabel29.Font.Color := 36095;
    WebLabel29.Font.Height := 11;
    WebLabel29.Font.Name := 'Tahoma';
    WebLabel29.Font.Style := [];
    WebLabel29.ParentFont := False;
    WebLabel29.Transparent := False;
    WebLabel80.SetParentComponent(WebGroupBox1);
    WebLabel80.Name := 'WebLabel80';
    WebLabel80.Left := 152;
    WebLabel80.Top := 20;
    WebLabel80.Width := 39;
    WebLabel80.Height := 11;
    WebLabel80.Caption := 'Ilo'#347#263' [szt]';
    WebLabel81.SetParentComponent(WebGroupBox1);
    WebLabel81.Name := 'WebLabel81';
    WebLabel81.Left := 235;
    WebLabel81.Top := 20;
    WebLabel81.Width := 34;
    WebLabel81.Height := 11;
    WebLabel81.Caption := 'Moc [W]';
    WebLabel82.SetParentComponent(WebGroupBox1);
    WebLabel82.Name := 'WebLabel82';
    WebLabel82.Left := 308;
    WebLabel82.Top := 20;
    WebLabel82.Width := 48;
    WebLabel82.Height := 11;
    WebLabel82.Caption := 'Czas [godz]';
    WebLabel83.SetParentComponent(WebGroupBox1);
    WebLabel83.Name := 'WebLabel83';
    WebLabel83.Left := 402;
    WebLabel83.Top := 20;
    WebLabel83.Width := 53;
    WebLabel83.Height := 11;
    WebLabel83.Caption := 'Energia [Wh]';
    WebEdit4.SetParentComponent(WebGroupBox1);
    WebEdit4.Name := 'WebEdit4';
    WebEdit4.Left := 231;
    WebEdit4.Top := 61;
    WebEdit4.Width := 41;
    WebEdit4.Height := 19;
    WebEdit4.ChildOrder := 12;
    WebEdit4.Color := clInfoBk;
    WebEdit4.Text := '0';
    SetEvent(WebEdit4, Self, 'OnKeyUp', 'WebEdit4KeyUp');
    WebEdit5.SetParentComponent(WebGroupBox1);
    WebEdit5.Name := 'WebEdit5';
    WebEdit5.Left := 231;
    WebEdit5.Top := 82;
    WebEdit5.Width := 41;
    WebEdit5.Height := 19;
    WebEdit5.ChildOrder := 13;
    WebEdit5.Color := clInfoBk;
    WebEdit5.Text := '0';
    SetEvent(WebEdit5, Self, 'OnKeyUp', 'WebEdit5KeyUp');
    WebEdit6.SetParentComponent(WebGroupBox1);
    WebEdit6.Name := 'WebEdit6';
    WebEdit6.Left := 231;
    WebEdit6.Top := 103;
    WebEdit6.Width := 41;
    WebEdit6.Height := 19;
    WebEdit6.ChildOrder := 14;
    WebEdit6.Color := clInfoBk;
    WebEdit6.Text := '0';
    SetEvent(WebEdit6, Self, 'OnKeyUp', 'WebEdit6KeyUp');
    WebEdit7.SetParentComponent(WebGroupBox1);
    WebEdit7.Name := 'WebEdit7';
    WebEdit7.Left := 231;
    WebEdit7.Top := 124;
    WebEdit7.Width := 41;
    WebEdit7.Height := 19;
    WebEdit7.ChildOrder := 15;
    WebEdit7.Color := clInfoBk;
    WebEdit7.Text := '0';
    SetEvent(WebEdit7, Self, 'OnKeyUp', 'WebEdit7KeyUp');
    WebEdit8.SetParentComponent(WebGroupBox1);
    WebEdit8.Name := 'WebEdit8';
    WebEdit8.Left := 231;
    WebEdit8.Top := 145;
    WebEdit8.Width := 41;
    WebEdit8.Height := 19;
    WebEdit8.ChildOrder := 16;
    WebEdit8.Color := clInfoBk;
    WebEdit8.Text := '0';
    SetEvent(WebEdit8, Self, 'OnKeyUp', 'WebEdit8KeyUp');
    WebEdit9.SetParentComponent(WebGroupBox1);
    WebEdit9.Name := 'WebEdit9';
    WebEdit9.Left := 231;
    WebEdit9.Top := 166;
    WebEdit9.Width := 41;
    WebEdit9.Height := 19;
    WebEdit9.ChildOrder := 17;
    WebEdit9.Color := clInfoBk;
    WebEdit9.Text := '0';
    SetEvent(WebEdit9, Self, 'OnKeyUp', 'WebEdit9KeyUp');
    WebEdit10.SetParentComponent(WebGroupBox1);
    WebEdit10.Name := 'WebEdit10';
    WebEdit10.Left := 231;
    WebEdit10.Top := 187;
    WebEdit10.Width := 41;
    WebEdit10.Height := 19;
    WebEdit10.ChildOrder := 18;
    WebEdit10.Color := clInfoBk;
    WebEdit10.Text := '0';
    SetEvent(WebEdit10, Self, 'OnKeyUp', 'WebEdit10KeyUp');
    WebEdit11.SetParentComponent(WebGroupBox1);
    WebEdit11.Name := 'WebEdit11';
    WebEdit11.Left := 231;
    WebEdit11.Top := 208;
    WebEdit11.Width := 41;
    WebEdit11.Height := 19;
    WebEdit11.ChildOrder := 19;
    WebEdit11.Color := clInfoBk;
    WebEdit11.Text := '0';
    SetEvent(WebEdit11, Self, 'OnKeyUp', 'WebEdit11KeyUp');
    WebEdit12.SetParentComponent(WebGroupBox1);
    WebEdit12.Name := 'WebEdit12';
    WebEdit12.Left := 231;
    WebEdit12.Top := 229;
    WebEdit12.Width := 41;
    WebEdit12.Height := 19;
    WebEdit12.ChildOrder := 20;
    WebEdit12.Color := clInfoBk;
    WebEdit12.Text := '0';
    SetEvent(WebEdit12, Self, 'OnKeyUp', 'WebEdit12KeyUp');
    WebEdit13.SetParentComponent(WebGroupBox1);
    WebEdit13.Name := 'WebEdit13';
    WebEdit13.Left := 158;
    WebEdit13.Top := 40;
    WebEdit13.Width := 33;
    WebEdit13.Height := 19;
    WebEdit13.ChildOrder := 31;
    WebEdit13.Color := clInfoBk;
    WebEdit13.Text := '0';
    SetEvent(WebEdit13, Self, 'OnKeyUp', 'WebEdit13KeyUp');
    WebEdit14.SetParentComponent(WebGroupBox1);
    WebEdit14.Name := 'WebEdit14';
    WebEdit14.Left := 158;
    WebEdit14.Top := 61;
    WebEdit14.Width := 33;
    WebEdit14.Height := 19;
    WebEdit14.ChildOrder := 31;
    WebEdit14.Color := clInfoBk;
    WebEdit14.Text := '0';
    SetEvent(WebEdit14, Self, 'OnKeyUp', 'WebEdit14KeyUp');
    WebEdit15.SetParentComponent(WebGroupBox1);
    WebEdit15.Name := 'WebEdit15';
    WebEdit15.Left := 158;
    WebEdit15.Top := 82;
    WebEdit15.Width := 33;
    WebEdit15.Height := 19;
    WebEdit15.ChildOrder := 31;
    WebEdit15.Color := clInfoBk;
    WebEdit15.Text := '0';
    SetEvent(WebEdit15, Self, 'OnKeyUp', 'WebEdit15KeyUp');
    WebEdit16.SetParentComponent(WebGroupBox1);
    WebEdit16.Name := 'WebEdit16';
    WebEdit16.Left := 158;
    WebEdit16.Top := 103;
    WebEdit16.Width := 33;
    WebEdit16.Height := 19;
    WebEdit16.ChildOrder := 31;
    WebEdit16.Color := clInfoBk;
    WebEdit16.Text := '0';
    SetEvent(WebEdit16, Self, 'OnKeyUp', 'WebEdit16KeyUp');
    WebEdit17.SetParentComponent(WebGroupBox1);
    WebEdit17.Name := 'WebEdit17';
    WebEdit17.Left := 158;
    WebEdit17.Top := 124;
    WebEdit17.Width := 33;
    WebEdit17.Height := 19;
    WebEdit17.ChildOrder := 31;
    WebEdit17.Color := clInfoBk;
    WebEdit17.Text := '0';
    SetEvent(WebEdit17, Self, 'OnKeyUp', 'WebEdit17KeyUp');
    WebEdit18.SetParentComponent(WebGroupBox1);
    WebEdit18.Name := 'WebEdit18';
    WebEdit18.Left := 158;
    WebEdit18.Top := 145;
    WebEdit18.Width := 33;
    WebEdit18.Height := 19;
    WebEdit18.ChildOrder := 31;
    WebEdit18.Color := clInfoBk;
    WebEdit18.Text := '0';
    SetEvent(WebEdit18, Self, 'OnKeyUp', 'WebEdit18KeyUp');
    WebEdit19.SetParentComponent(WebGroupBox1);
    WebEdit19.Name := 'WebEdit19';
    WebEdit19.Left := 158;
    WebEdit19.Top := 166;
    WebEdit19.Width := 33;
    WebEdit19.Height := 19;
    WebEdit19.ChildOrder := 31;
    WebEdit19.Color := clInfoBk;
    WebEdit19.Text := '0';
    SetEvent(WebEdit19, Self, 'OnKeyUp', 'WebEdit19KeyUp');
    WebEdit20.SetParentComponent(WebGroupBox1);
    WebEdit20.Name := 'WebEdit20';
    WebEdit20.Left := 158;
    WebEdit20.Top := 187;
    WebEdit20.Width := 33;
    WebEdit20.Height := 19;
    WebEdit20.ChildOrder := 31;
    WebEdit20.Color := clInfoBk;
    WebEdit20.Text := '0';
    SetEvent(WebEdit20, Self, 'OnKeyUp', 'WebEdit20KeyUp');
    WebEdit21.SetParentComponent(WebGroupBox1);
    WebEdit21.Name := 'WebEdit21';
    WebEdit21.Left := 158;
    WebEdit21.Top := 208;
    WebEdit21.Width := 33;
    WebEdit21.Height := 19;
    WebEdit21.ChildOrder := 31;
    WebEdit21.Color := clInfoBk;
    WebEdit21.Text := '0';
    SetEvent(WebEdit21, Self, 'OnKeyUp', 'WebEdit21KeyUp');
    WebEdit22.SetParentComponent(WebGroupBox1);
    WebEdit22.Name := 'WebEdit22';
    WebEdit22.Left := 158;
    WebEdit22.Top := 229;
    WebEdit22.Width := 33;
    WebEdit22.Height := 19;
    WebEdit22.ChildOrder := 31;
    WebEdit22.Color := clInfoBk;
    WebEdit22.Text := '0';
    SetEvent(WebEdit22, Self, 'OnKeyUp', 'WebEdit22KeyUp');
    WebEdit23.SetParentComponent(WebGroupBox1);
    WebEdit23.Name := 'WebEdit23';
    WebEdit23.Left := 321;
    WebEdit23.Top := 40;
    WebEdit23.Width := 33;
    WebEdit23.Height := 19;
    WebEdit23.ChildOrder := 31;
    WebEdit23.Color := clInfoBk;
    WebEdit23.Text := '0';
    SetEvent(WebEdit23, Self, 'OnKeyUp', 'WebEdit23KeyUp');
    WebEdit24.SetParentComponent(WebGroupBox1);
    WebEdit24.Name := 'WebEdit24';
    WebEdit24.Left := 321;
    WebEdit24.Top := 61;
    WebEdit24.Width := 33;
    WebEdit24.Height := 19;
    WebEdit24.ChildOrder := 31;
    WebEdit24.Color := clInfoBk;
    WebEdit24.Text := '0';
    SetEvent(WebEdit24, Self, 'OnKeyUp', 'WebEdit24KeyUp');
    WebEdit25.SetParentComponent(WebGroupBox1);
    WebEdit25.Name := 'WebEdit25';
    WebEdit25.Left := 321;
    WebEdit25.Top := 82;
    WebEdit25.Width := 33;
    WebEdit25.Height := 19;
    WebEdit25.ChildOrder := 31;
    WebEdit25.Color := clInfoBk;
    WebEdit25.Text := '0';
    SetEvent(WebEdit25, Self, 'OnKeyUp', 'WebEdit25KeyUp');
    WebEdit26.SetParentComponent(WebGroupBox1);
    WebEdit26.Name := 'WebEdit26';
    WebEdit26.Left := 321;
    WebEdit26.Top := 103;
    WebEdit26.Width := 33;
    WebEdit26.Height := 19;
    WebEdit26.ChildOrder := 31;
    WebEdit26.Color := clInfoBk;
    WebEdit26.Text := '0';
    SetEvent(WebEdit26, Self, 'OnKeyUp', 'WebEdit26KeyUp');
    WebEdit27.SetParentComponent(WebGroupBox1);
    WebEdit27.Name := 'WebEdit27';
    WebEdit27.Left := 321;
    WebEdit27.Top := 124;
    WebEdit27.Width := 33;
    WebEdit27.Height := 19;
    WebEdit27.ChildOrder := 31;
    WebEdit27.Color := clInfoBk;
    WebEdit27.Text := '0';
    SetEvent(WebEdit27, Self, 'OnKeyUp', 'WebEdit27KeyUp');
    WebEdit28.SetParentComponent(WebGroupBox1);
    WebEdit28.Name := 'WebEdit28';
    WebEdit28.Left := 321;
    WebEdit28.Top := 145;
    WebEdit28.Width := 33;
    WebEdit28.Height := 19;
    WebEdit28.ChildOrder := 31;
    WebEdit28.Color := clInfoBk;
    WebEdit28.Text := '0';
    SetEvent(WebEdit28, Self, 'OnKeyUp', 'WebEdit28KeyUp');
    WebEdit29.SetParentComponent(WebGroupBox1);
    WebEdit29.Name := 'WebEdit29';
    WebEdit29.Left := 321;
    WebEdit29.Top := 166;
    WebEdit29.Width := 33;
    WebEdit29.Height := 19;
    WebEdit29.ChildOrder := 31;
    WebEdit29.Color := clInfoBk;
    WebEdit29.Text := '0';
    SetEvent(WebEdit29, Self, 'OnKeyUp', 'WebEdit29KeyUp');
    WebEdit30.SetParentComponent(WebGroupBox1);
    WebEdit30.Name := 'WebEdit30';
    WebEdit30.Left := 321;
    WebEdit30.Top := 187;
    WebEdit30.Width := 33;
    WebEdit30.Height := 19;
    WebEdit30.ChildOrder := 31;
    WebEdit30.Color := clInfoBk;
    WebEdit30.Text := '0';
    SetEvent(WebEdit30, Self, 'OnKeyUp', 'WebEdit30KeyUp');
    WebEdit31.SetParentComponent(WebGroupBox1);
    WebEdit31.Name := 'WebEdit31';
    WebEdit31.Left := 321;
    WebEdit31.Top := 208;
    WebEdit31.Width := 33;
    WebEdit31.Height := 19;
    WebEdit31.ChildOrder := 31;
    WebEdit31.Color := clInfoBk;
    WebEdit31.Text := '0';
    SetEvent(WebEdit31, Self, 'OnKeyUp', 'WebEdit31KeyUp');
    WebEdit32.SetParentComponent(WebGroupBox1);
    WebEdit32.Name := 'WebEdit32';
    WebEdit32.Left := 321;
    WebEdit32.Top := 229;
    WebEdit32.Width := 33;
    WebEdit32.Height := 19;
    WebEdit32.ChildOrder := 31;
    WebEdit32.Color := clInfoBk;
    WebEdit32.Text := '0';
    SetEvent(WebEdit32, Self, 'OnKeyUp', 'WebEdit32KeyUp');
    WebEdit33.SetParentComponent(WebGroupBox1);
    WebEdit33.Name := 'WebEdit33';
    WebEdit33.Left := 414;
    WebEdit33.Top := 40;
    WebEdit33.Width := 50;
    WebEdit33.Height := 19;
    WebEdit33.ChildOrder := 20;
    WebEdit33.Color := clBtnFace;
    WebEdit33.Enabled := False;
    WebEdit33.Text := '0';
    SetEvent(WebEdit33, Self, 'OnKeyUp', 'WebEdit33KeyUp');
    WebEdit34.SetParentComponent(WebGroupBox1);
    WebEdit34.Name := 'WebEdit34';
    WebEdit34.Left := 414;
    WebEdit34.Top := 61;
    WebEdit34.Width := 50;
    WebEdit34.Height := 19;
    WebEdit34.ChildOrder := 19;
    WebEdit34.Color := clBtnFace;
    WebEdit34.Enabled := False;
    WebEdit34.Text := '0';
    SetEvent(WebEdit34, Self, 'OnKeyUp', 'WebEdit34KeyUp');
    WebEdit35.SetParentComponent(WebGroupBox1);
    WebEdit35.Name := 'WebEdit35';
    WebEdit35.Left := 414;
    WebEdit35.Top := 82;
    WebEdit35.Width := 50;
    WebEdit35.Height := 19;
    WebEdit35.ChildOrder := 18;
    WebEdit35.Color := clBtnFace;
    WebEdit35.Enabled := False;
    WebEdit35.Text := '0';
    SetEvent(WebEdit35, Self, 'OnKeyUp', 'WebEdit35KeyUp');
    WebEdit36.SetParentComponent(WebGroupBox1);
    WebEdit36.Name := 'WebEdit36';
    WebEdit36.Left := 414;
    WebEdit36.Top := 103;
    WebEdit36.Width := 50;
    WebEdit36.Height := 19;
    WebEdit36.ChildOrder := 17;
    WebEdit36.Color := clBtnFace;
    WebEdit36.Enabled := False;
    WebEdit36.Text := '0';
    SetEvent(WebEdit36, Self, 'OnKeyUp', 'WebEdit36KeyUp');
    WebEdit37.SetParentComponent(WebGroupBox1);
    WebEdit37.Name := 'WebEdit37';
    WebEdit37.Left := 414;
    WebEdit37.Top := 124;
    WebEdit37.Width := 50;
    WebEdit37.Height := 19;
    WebEdit37.ChildOrder := 16;
    WebEdit37.Color := clBtnFace;
    WebEdit37.Enabled := False;
    WebEdit37.Text := '0';
    SetEvent(WebEdit37, Self, 'OnKeyUp', 'WebEdit37KeyUp');
    WebEdit38.SetParentComponent(WebGroupBox1);
    WebEdit38.Name := 'WebEdit38';
    WebEdit38.Left := 414;
    WebEdit38.Top := 145;
    WebEdit38.Width := 50;
    WebEdit38.Height := 19;
    WebEdit38.ChildOrder := 15;
    WebEdit38.Color := clBtnFace;
    WebEdit38.Enabled := False;
    WebEdit38.Text := '0';
    SetEvent(WebEdit38, Self, 'OnKeyUp', 'WebEdit38KeyUp');
    WebEdit39.SetParentComponent(WebGroupBox1);
    WebEdit39.Name := 'WebEdit39';
    WebEdit39.Left := 414;
    WebEdit39.Top := 166;
    WebEdit39.Width := 50;
    WebEdit39.Height := 19;
    WebEdit39.ChildOrder := 14;
    WebEdit39.Color := clBtnFace;
    WebEdit39.Enabled := False;
    WebEdit39.Text := '0';
    SetEvent(WebEdit39, Self, 'OnKeyUp', 'WebEdit39KeyUp');
    WebEdit40.SetParentComponent(WebGroupBox1);
    WebEdit40.Name := 'WebEdit40';
    WebEdit40.Left := 414;
    WebEdit40.Top := 187;
    WebEdit40.Width := 50;
    WebEdit40.Height := 19;
    WebEdit40.ChildOrder := 13;
    WebEdit40.Color := clBtnFace;
    WebEdit40.Enabled := False;
    WebEdit40.Text := '0';
    SetEvent(WebEdit40, Self, 'OnKeyUp', 'WebEdit40KeyUp');
    WebEdit41.SetParentComponent(WebGroupBox1);
    WebEdit41.Name := 'WebEdit41';
    WebEdit41.Left := 414;
    WebEdit41.Top := 208;
    WebEdit41.Width := 50;
    WebEdit41.Height := 19;
    WebEdit41.ChildOrder := 12;
    WebEdit41.Color := clBtnFace;
    WebEdit41.Enabled := False;
    WebEdit41.Text := '0';
    SetEvent(WebEdit41, Self, 'OnKeyUp', 'WebEdit41KeyUp');
    WebEdit42.SetParentComponent(WebGroupBox1);
    WebEdit42.Name := 'WebEdit42';
    WebEdit42.Left := 414;
    WebEdit42.Top := 229;
    WebEdit42.Width := 50;
    WebEdit42.Height := 19;
    WebEdit42.ChildOrder := 11;
    WebEdit42.Color := clBtnFace;
    WebEdit42.Enabled := False;
    WebEdit42.Text := '0';
    SetEvent(WebEdit42, Self, 'OnKeyUp', 'WebEdit42KeyUp');
    WebEdit43.SetParentComponent(WebGroupBox1);
    WebEdit43.Name := 'WebEdit43';
    WebEdit43.Left := 157;
    WebEdit43.Top := 252;
    WebEdit43.Width := 33;
    WebEdit43.Height := 19;
    WebEdit43.ChildOrder := 31;
    WebEdit43.Color := 12903679;
    WebEdit43.Enabled := False;
    WebEdit43.Text := '0';
    WebEdit44.SetParentComponent(WebGroupBox1);
    WebEdit44.Name := 'WebEdit44';
    WebEdit44.Left := 230;
    WebEdit44.Top := 252;
    WebEdit44.Width := 41;
    WebEdit44.Height := 19;
    WebEdit44.ChildOrder := 20;
    WebEdit44.Color := 12903679;
    WebEdit44.Enabled := False;
    WebEdit44.Text := '0';
    WebEdit45.SetParentComponent(WebGroupBox1);
    WebEdit45.Name := 'WebEdit45';
    WebEdit45.Left := 320;
    WebEdit45.Top := 252;
    WebEdit45.Width := 33;
    WebEdit45.Height := 19;
    WebEdit45.ChildOrder := 31;
    WebEdit45.Color := 12903679;
    WebEdit45.Enabled := False;
    WebEdit45.Text := '0';
    WebEdit46.SetParentComponent(WebGroupBox1);
    WebEdit46.Name := 'WebEdit46';
    WebEdit46.Left := 414;
    WebEdit46.Top := 252;
    WebEdit46.Width := 50;
    WebEdit46.Height := 19;
    WebEdit46.ChildOrder := 20;
    WebEdit46.Color := clBtnFace;
    WebEdit46.Enabled := False;
    WebEdit46.Text := '0';
    WebEdit3.SetParentComponent(WebGroupBox1);
    WebEdit3.Name := 'WebEdit3';
    WebEdit3.Left := 231;
    WebEdit3.Top := 40;
    WebEdit3.Width := 41;
    WebEdit3.Height := 19;
    WebEdit3.ChildOrder := 3;
    WebEdit3.Color := clInfoBk;
    WebEdit3.Font.Charset := DEFAULT_CHARSET;
    WebEdit3.Font.Color := clWindowText;
    WebEdit3.Font.Height := 11;
    WebEdit3.Font.Name := 'Tahoma';
    WebEdit3.Font.Style := [];
    WebEdit3.ParentFont := False;
    WebEdit3.Text := '0';
    SetEvent(WebEdit3, Self, 'OnKeyUp', 'WebEdit3KeyUp');
    WebGroupBox2.SetParentComponent(Self);
    WebGroupBox2.Name := 'WebGroupBox2';
    WebGroupBox2.Left := 505;
    WebGroupBox2.Top := 463;
    WebGroupBox2.Width := 401;
    WebGroupBox2.Height := 137;
    WebGroupBox2.Caption := 'Dane dodatkowe  ';
    WebGroupBox2.ChildOrder := 3;
    WebGroupBox2.Color := clWhite;
    WebGroupBox2.Font.Charset := DEFAULT_CHARSET;
    WebGroupBox2.Font.Color := clWindowText;
    WebGroupBox2.Font.Height := 11;
    WebGroupBox2.Font.Name := 'Tahoma';
    WebGroupBox2.Font.Style := [];
    WebGroupBox2.ParentFont := False;
    WebLabel2.SetParentComponent(WebGroupBox2);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 12;
    WebLabel2.Top := 19;
    WebLabel2.Width := 106;
    WebLabel2.Height := 11;
    WebLabel2.Caption := 'Napi'#281'cie akumulatora DC';
    WebLabel3.SetParentComponent(WebGroupBox2);
    WebLabel3.Name := 'WebLabel3';
    WebLabel3.Left := 349;
    WebLabel3.Top := 19;
    WebLabel3.Width := 7;
    WebLabel3.Height := 11;
    WebLabel3.Caption := 'V';
    WebLabel14.SetParentComponent(WebGroupBox2);
    WebLabel14.Name := 'WebLabel14';
    WebLabel14.Left := 12;
    WebLabel14.Top := 91;
    WebLabel14.Width := 131;
    WebLabel14.Height := 11;
    WebLabel14.Caption := #346'rednie dzienne nas'#322'onecznienie';
    WebLabel4.SetParentComponent(WebGroupBox2);
    WebLabel4.Name := 'WebLabel4';
    WebLabel4.Left := 12;
    WebLabel4.Top := 41;
    WebLabel4.Width := 108;
    WebLabel4.Height := 11;
    WebLabel4.Caption := 'Liczba dni autonomicznych';
    WebLabel6.SetParentComponent(WebGroupBox2);
    WebLabel6.Name := 'WebLabel6';
    WebLabel6.Left := 12;
    WebLabel6.Top := 65;
    WebLabel6.Width := 90;
    WebLabel6.Height := 11;
    WebLabel6.Caption := 'Rodzaj akumulator'#243'w';
    WebLabel5.SetParentComponent(WebGroupBox2);
    WebLabel5.Name := 'WebLabel5';
    WebLabel5.Left := 349;
    WebLabel5.Top := 42;
    WebLabel5.Width := 12;
    WebLabel5.Height := 11;
    WebLabel5.Caption := 'dni';
    WebLabel9.SetParentComponent(WebGroupBox2);
    WebLabel9.Name := 'WebLabel9';
    WebLabel9.Left := 12;
    WebLabel9.Top := 113;
    WebLabel9.Width := 109;
    WebLabel9.Height := 11;
    WebLabel9.Caption := 'D'#322'ugo'#347#263' kabla zasilaj'#261'cego';
    WebLabel36.SetParentComponent(WebGroupBox2);
    WebLabel36.Name := 'WebLabel36';
    WebLabel36.Left := 351;
    WebLabel36.Top := 113;
    WebLabel36.Width := 8;
    WebLabel36.Height := 11;
    WebLabel36.Caption := 'm';
    WebComboBox3.SetParentComponent(WebGroupBox2);
    WebComboBox3.Name := 'WebComboBox3';
    WebComboBox3.Left := 281;
    WebComboBox3.Top := 14;
    WebComboBox3.Width := 62;
    WebComboBox3.Height := 22;
    WebComboBox3.Color := clInfoBk;
    WebComboBox3.Text := '12';
    SetEvent(WebComboBox3, Self, 'OnChange', 'WebComboBox3Change');
    WebComboBox3.ItemIndex := 0;
    WebComboBox3.Items.BeginUpdate;
    try
      WebComboBox3.Items.Clear;
      WebComboBox3.Items.Add('12');
      WebComboBox3.Items.Add('24');
    finally
      WebComboBox3.Items.EndUpdate;
    end;
    WebComboBox1.SetParentComponent(WebGroupBox2);
    WebComboBox1.Name := 'WebComboBox1';
    WebComboBox1.Left := 281;
    WebComboBox1.Top := 38;
    WebComboBox1.Width := 62;
    WebComboBox1.Height := 22;
    WebComboBox1.Color := clInfoBk;
    WebComboBox1.Text := '10';
    SetEvent(WebComboBox1, Self, 'OnChange', 'WebComboBox1Change');
    WebComboBox1.ItemIndex := 9;
    WebComboBox1.Items.BeginUpdate;
    try
      WebComboBox1.Items.Clear;
      WebComboBox1.Items.Add('1');
      WebComboBox1.Items.Add('2');
      WebComboBox1.Items.Add('3');
      WebComboBox1.Items.Add('4');
      WebComboBox1.Items.Add('5');
      WebComboBox1.Items.Add('6');
      WebComboBox1.Items.Add('7');
      WebComboBox1.Items.Add('8');
      WebComboBox1.Items.Add('9');
      WebComboBox1.Items.Add('10');
      WebComboBox1.Items.Add('11');
      WebComboBox1.Items.Add('12');
      WebComboBox1.Items.Add('13');
      WebComboBox1.Items.Add('14');
      WebComboBox1.Items.Add('15');
    finally
      WebComboBox1.Items.EndUpdate;
    end;
    WebComboBox2.SetParentComponent(WebGroupBox2);
    WebComboBox2.Name := 'WebComboBox2';
    WebComboBox2.Left := 281;
    WebComboBox2.Top := 62;
    WebComboBox2.Width := 92;
    WebComboBox2.Height := 22;
    WebComboBox2.Color := clInfoBk;
    WebComboBox2.Text := 'kwasowe';
    SetEvent(WebComboBox2, Self, 'OnChange', 'WebComboBox2Change');
    WebComboBox2.ItemIndex := 0;
    WebComboBox2.Items.BeginUpdate;
    try
      WebComboBox2.Items.Clear;
      WebComboBox2.Items.Add('kwasowe');
      WebComboBox2.Items.Add('Li-ION');
    finally
      WebComboBox2.Items.EndUpdate;
    end;
    WebComboBox4.SetParentComponent(WebGroupBox2);
    WebComboBox4.Name := 'WebComboBox4';
    WebComboBox4.Left := 281;
    WebComboBox4.Top := 86;
    WebComboBox4.Width := 92;
    WebComboBox4.Height := 22;
    WebComboBox4.Color := clInfoBk;
    WebComboBox4.Font.Charset := DEFAULT_CHARSET;
    WebComboBox4.Font.Color := clBlack;
    WebComboBox4.Font.Height := 11;
    WebComboBox4.Font.Name := 'Tahoma';
    WebComboBox4.Font.Style := [];
    WebComboBox4.ParentFont := False;
    WebComboBox4.Text := 'Bia'#322'ystok';
    SetEvent(WebComboBox4, Self, 'OnChange', 'WebComboBox4Change');
    WebComboBox4.ItemIndex := 0;
    WebComboBox4.Items.BeginUpdate;
    try
      WebComboBox4.Items.Clear;
      WebComboBox4.Items.Add('Bia'#322'ystok');
      WebComboBox4.Items.Add('Bielsko-Bia'#322'a');
      WebComboBox4.Items.Add('Bydgoszcz');
      WebComboBox4.Items.Add('Byt'#243'w');
      WebComboBox4.Items.Add('Che'#322'm');
      WebComboBox4.Items.Add('Cz'#281'stochowa');
      WebComboBox4.Items.Add('Drawsko Pomorskie');
      WebComboBox4.Items.Add('Elbl'#261'g');
      WebComboBox4.Items.Add('Gda'#324's');
      WebComboBox4.Items.Add('Gdyni');
      WebComboBox4.Items.Add('Gi'#380'ycko');
      WebComboBox4.Items.Add('Gorz'#243'w Wielkopolski');
      WebComboBox4.Items.Add('Grudzi'#261'dz 1251.5');
      WebComboBox4.Items.Add('I'#322'awa');
      WebComboBox4.Items.Add('Kalisz');
      WebComboBox4.Items.Add('Katowice');
      WebComboBox4.Items.Add('Kielce');
      WebComboBox4.Items.Add('Konin');
      WebComboBox4.Items.Add('Koszalin');
      WebComboBox4.Items.Add('Krak'#243'w');
      WebComboBox4.Items.Add('Krosno');
      WebComboBox4.Items.Add('Legnica');
      WebComboBox4.Items.Add('Leszno');
      WebComboBox4.Items.Add('Lublin'#321);
      WebComboBox4.Items.Add('om'#380'a'#321#243);
      WebComboBox4.Items.Add('d'#378);
      WebComboBox4.Items.Add('Nowy S'#261'cz');
      WebComboBox4.Items.Add('Olsztyn');
      WebComboBox4.Items.Add('Opole');
      WebComboBox4.Items.Add('Ostro'#322#281'ka');
      WebComboBox4.Items.Add('Pi'#322'a');
      WebComboBox4.Items.Add('Piotrk'#243'w Trybunalski');
      WebComboBox4.Items.Add('P'#322'ock');
      WebComboBox4.Items.Add('Pozna'#324);
      WebComboBox4.Items.Add('Przemy'#347'l');
      WebComboBox4.Items.Add('Radom');
      WebComboBox4.Items.Add('Rzesz'#243'w');
      WebComboBox4.Items.Add('Rybnik');
      WebComboBox4.Items.Add('Sandomierz');
      WebComboBox4.Items.Add('Siedlce');
      WebComboBox4.Items.Add('Skierniewice');
      WebComboBox4.Items.Add('S'#322'upsk');
      WebComboBox4.Items.Add('Suwa'#322'ki');
      WebComboBox4.Items.Add('Szczecin');
      WebComboBox4.Items.Add('Szczecinek'#346);
      WebComboBox4.Items.Add('wiebodzin'#346);
      WebComboBox4.Items.Add('winouj'#347'cie');
      WebComboBox4.Items.Add('Tarnobrzeg');
      WebComboBox4.Items.Add('Tarn'#243'w');
      WebComboBox4.Items.Add('Toru'#324);
      WebComboBox4.Items.Add('Wa'#322'brzych');
      WebComboBox4.Items.Add('Warszawa');
      WebComboBox4.Items.Add('W'#322'oc'#322'awek');
      WebComboBox4.Items.Add('Wroc'#322'aw');
      WebComboBox4.Items.Add('Zamo'#347#263);
      WebComboBox4.Items.Add('Zielona G'#243'ra'#379);
      WebComboBox4.Items.Add('ary');
    finally
      WebComboBox4.Items.EndUpdate;
    end;
    WebComboBox5.SetParentComponent(WebGroupBox2);
    WebComboBox5.Name := 'WebComboBox5';
    WebComboBox5.Left := 281;
    WebComboBox5.Top := 110;
    WebComboBox5.Width := 62;
    WebComboBox5.Height := 22;
    WebComboBox5.Color := clInfoBk;
    WebComboBox5.Text := '10';
    SetEvent(WebComboBox5, Self, 'OnChange', 'WebComboBox5Change');
    WebComboBox5.ItemIndex := 9;
    WebComboBox5.Items.BeginUpdate;
    try
      WebComboBox5.Items.Clear;
      WebComboBox5.Items.Add('1');
      WebComboBox5.Items.Add('2');
      WebComboBox5.Items.Add('3');
      WebComboBox5.Items.Add('4');
      WebComboBox5.Items.Add('5');
      WebComboBox5.Items.Add('6');
      WebComboBox5.Items.Add('7');
      WebComboBox5.Items.Add('8');
      WebComboBox5.Items.Add('9');
      WebComboBox5.Items.Add('10');
      WebComboBox5.Items.Add('11');
      WebComboBox5.Items.Add('12');
      WebComboBox5.Items.Add('13');
      WebComboBox5.Items.Add('14');
      WebComboBox5.Items.Add('15');
      WebComboBox5.Items.Add('16');
      WebComboBox5.Items.Add('17');
      WebComboBox5.Items.Add('18');
      WebComboBox5.Items.Add('19');
      WebComboBox5.Items.Add('20');
      WebComboBox5.Items.Add('21');
      WebComboBox5.Items.Add('22');
      WebComboBox5.Items.Add('23');
      WebComboBox5.Items.Add('24');
      WebComboBox5.Items.Add('25');
      WebComboBox5.Items.Add('26');
      WebComboBox5.Items.Add('27');
      WebComboBox5.Items.Add('28');
      WebComboBox5.Items.Add('29');
      WebComboBox5.Items.Add('30');
      WebComboBox5.Items.Add('31');
      WebComboBox5.Items.Add('32');
      WebComboBox5.Items.Add('33');
      WebComboBox5.Items.Add('34');
      WebComboBox5.Items.Add('35');
      WebComboBox5.Items.Add('36');
      WebComboBox5.Items.Add('37');
      WebComboBox5.Items.Add('38');
      WebComboBox5.Items.Add('39');
      WebComboBox5.Items.Add('40');
      WebComboBox5.Items.Add('41');
      WebComboBox5.Items.Add('42');
      WebComboBox5.Items.Add('43');
      WebComboBox5.Items.Add('44');
      WebComboBox5.Items.Add('45');
      WebComboBox5.Items.Add('46');
      WebComboBox5.Items.Add('47');
      WebComboBox5.Items.Add('48');
      WebComboBox5.Items.Add('49');
      WebComboBox5.Items.Add('50');
    finally
      WebComboBox5.Items.EndUpdate;
    end;
    WebGroupBox3.SetParentComponent(Self);
    WebGroupBox3.Name := 'WebGroupBox3';
    WebGroupBox3.Left := 505;
    WebGroupBox3.Top := 605;
    WebGroupBox3.Width := 401;
    WebGroupBox3.Height := 145;
    WebGroupBox3.Caption := 'Dane instalacji off-grid ';
    WebGroupBox3.ChildOrder := 11;
    WebGroupBox3.Font.Charset := DEFAULT_CHARSET;
    WebGroupBox3.Font.Color := clWindowText;
    WebGroupBox3.Font.Height := 11;
    WebGroupBox3.Font.Name := 'Tahoma';
    WebGroupBox3.Font.Style := [];
    WebGroupBox3.ParentFont := False;
    WebLabel30.SetParentComponent(WebGroupBox3);
    WebLabel30.Name := 'WebLabel30';
    WebLabel30.Left := 12;
    WebLabel30.Top := 66;
    WebLabel30.Width := 107;
    WebLabel30.Height := 11;
    WebLabel30.Caption := 'Pojemno'#347#263' akumulator'#243'w';
    WebLabel30.Font.Charset := DEFAULT_CHARSET;
    WebLabel30.Font.Color := clHighlight;
    WebLabel30.Font.Height := 11;
    WebLabel30.Font.Name := 'Tahoma';
    WebLabel30.Font.Style := [];
    WebLabel30.ParentFont := False;
    WebLabel31.SetParentComponent(WebGroupBox3);
    WebLabel31.Name := 'WebLabel31';
    WebLabel31.Left := 346;
    WebLabel31.Top := 66;
    WebLabel31.Width := 12;
    WebLabel31.Height := 11;
    WebLabel31.Caption := 'Ah';
    WebLabel31.Font.Charset := DEFAULT_CHARSET;
    WebLabel31.Font.Color := clWindowText;
    WebLabel31.Font.Height := 11;
    WebLabel31.Font.Name := 'Tahoma';
    WebLabel31.Font.Style := [];
    WebLabel31.ParentFont := False;
    WebLabel32.SetParentComponent(WebGroupBox3);
    WebLabel32.Name := 'WebLabel32';
    WebLabel32.Left := 12;
    WebLabel32.Top := 87;
    WebLabel32.Width := 138;
    WebLabel32.Height := 11;
    WebLabel32.Caption := 'Energia '#322'adowania akumulator'#243'w';
    WebLabel32.Font.Charset := DEFAULT_CHARSET;
    WebLabel32.Font.Color := clHighlight;
    WebLabel32.Font.Height := 11;
    WebLabel32.Font.Name := 'Tahoma';
    WebLabel32.Font.Style := [];
    WebLabel32.ParentFont := False;
    WebLabel33.SetParentComponent(WebGroupBox3);
    WebLabel33.Name := 'WebLabel33';
    WebLabel33.Left := 346;
    WebLabel33.Top := 87;
    WebLabel33.Width := 13;
    WebLabel33.Height := 11;
    WebLabel33.Caption := 'Wh';
    WebLabel33.Font.Charset := DEFAULT_CHARSET;
    WebLabel33.Font.Color := clWindowText;
    WebLabel33.Font.Height := 11;
    WebLabel33.Font.Name := 'Tahoma';
    WebLabel33.Font.Style := [];
    WebLabel33.ParentFont := False;
    WebLabel34.SetParentComponent(WebGroupBox3);
    WebLabel34.Name := 'WebLabel34';
    WebLabel34.Left := 12;
    WebLabel34.Top := 107;
    WebLabel34.Width := 129;
    WebLabel34.Height := 11;
    WebLabel34.Caption := 'Czas '#322'adowania (warunki STC)';
    WebLabel34.Font.Charset := DEFAULT_CHARSET;
    WebLabel34.Font.Color := clHighlight;
    WebLabel34.Font.Height := 11;
    WebLabel34.Font.Name := 'Tahoma';
    WebLabel34.Font.Style := [];
    WebLabel34.ParentFont := False;
    WebLabel35.SetParentComponent(WebGroupBox3);
    WebLabel35.Name := 'WebLabel35';
    WebLabel35.Left := 346;
    WebLabel35.Top := 107;
    WebLabel35.Width := 29;
    WebLabel35.Height := 11;
    WebLabel35.Caption := 'h/dzie'#324;
    WebLabel35.Font.Charset := DEFAULT_CHARSET;
    WebLabel35.Font.Color := clWindowText;
    WebLabel35.Font.Height := 11;
    WebLabel35.Font.Name := 'Tahoma';
    WebLabel35.Font.Style := [];
    WebLabel35.ParentFont := False;
    WebLabel38.SetParentComponent(WebGroupBox3);
    WebLabel38.Name := 'WebLabel38';
    WebLabel38.Left := 12;
    WebLabel38.Top := 128;
    WebLabel38.Width := 71;
    WebLabel38.Height := 11;
    WebLabel38.Caption := 'Moc instalacji PV';
    WebLabel38.Font.Charset := DEFAULT_CHARSET;
    WebLabel38.Font.Color := clHighlight;
    WebLabel38.Font.Height := 11;
    WebLabel38.Font.Name := 'Tahoma';
    WebLabel38.Font.Style := [];
    WebLabel38.ParentFont := False;
    WebLabel39.SetParentComponent(WebGroupBox3);
    WebLabel39.Name := 'WebLabel39';
    WebLabel39.Left := 346;
    WebLabel39.Top := 128;
    WebLabel39.Width := 13;
    WebLabel39.Height := 11;
    WebLabel39.Caption := 'Wp';
    WebLabel39.Font.Charset := DEFAULT_CHARSET;
    WebLabel39.Font.Color := clWindowText;
    WebLabel39.Font.Height := 11;
    WebLabel39.Font.Name := 'Tahoma';
    WebLabel39.Font.Style := [];
    WebLabel39.ParentFont := False;
    WebLabel7.SetParentComponent(WebGroupBox3);
    WebLabel7.Name := 'WebLabel7';
    WebLabel7.Left := 12;
    WebLabel7.Top := 23;
    WebLabel7.Width := 96;
    WebLabel7.Height := 11;
    WebLabel7.Caption := 'Dzienne zu'#380'ycie energii';
    WebLabel7.Font.Charset := DEFAULT_CHARSET;
    WebLabel7.Font.Color := clHighlight;
    WebLabel7.Font.Height := 11;
    WebLabel7.Font.Name := 'Tahoma';
    WebLabel7.Font.Style := [];
    WebLabel7.ParentFont := False;
    WebLabel8.SetParentComponent(WebGroupBox3);
    WebLabel8.Name := 'WebLabel8';
    WebLabel8.Left := 346;
    WebLabel8.Top := 23;
    WebLabel8.Width := 13;
    WebLabel8.Height := 11;
    WebLabel8.Caption := 'Wh';
    WebLabel8.Font.Charset := DEFAULT_CHARSET;
    WebLabel8.Font.Color := clWindowText;
    WebLabel8.Font.Height := 11;
    WebLabel8.Font.Name := 'Tahoma';
    WebLabel8.Font.Style := [];
    WebLabel8.ParentFont := False;
    WebLabel10.SetParentComponent(WebGroupBox3);
    WebLabel10.Name := 'WebLabel10';
    WebLabel10.Left := 12;
    WebLabel10.Top := 44;
    WebLabel10.Width := 77;
    WebLabel10.Height := 11;
    WebLabel10.Caption := 'Przekr'#243'j przewodu';
    WebLabel10.Font.Charset := DEFAULT_CHARSET;
    WebLabel10.Font.Color := clHighlight;
    WebLabel10.Font.Height := 11;
    WebLabel10.Font.Name := 'Tahoma';
    WebLabel10.Font.Style := [];
    WebLabel10.ParentFont := False;
    WebLabel10.Transparent := False;
    WebLabel13.SetParentComponent(WebGroupBox3);
    WebLabel13.Name := 'WebLabel13';
    WebLabel13.Left := 346;
    WebLabel13.Top := 44;
    WebLabel13.Width := 21;
    WebLabel13.Height := 11;
    WebLabel13.Caption := 'mm2';
    WebEdit2.SetParentComponent(WebGroupBox3);
    WebEdit2.Name := 'WebEdit2';
    WebEdit2.Left := 281;
    WebEdit2.Top := 20;
    WebEdit2.Width := 60;
    WebEdit2.Height := 19;
    WebEdit2.Color := clAqua;
    WebEdit2.Enabled := False;
    WebEdit2.Font.Charset := DEFAULT_CHARSET;
    WebEdit2.Font.Color := clWindowText;
    WebEdit2.Font.Height := 11;
    WebEdit2.Font.Name := 'Tahoma';
    WebEdit2.Font.Style := [];
    WebEdit2.ParentFont := False;
    WebEdit2.Text := '0';
    WebEdit47.SetParentComponent(WebGroupBox3);
    WebEdit47.Name := 'WebEdit47';
    WebEdit47.Left := 281;
    WebEdit47.Top := 62;
    WebEdit47.Width := 60;
    WebEdit47.Height := 19;
    WebEdit47.ChildOrder := 2;
    WebEdit47.Color := clAqua;
    WebEdit47.Enabled := False;
    WebEdit47.Font.Charset := DEFAULT_CHARSET;
    WebEdit47.Font.Color := clWindowText;
    WebEdit47.Font.Height := 11;
    WebEdit47.Font.Name := 'Tahoma';
    WebEdit47.Font.Style := [];
    WebEdit47.ParentFont := False;
    WebEdit47.Text := '0';
    WebEdit48.SetParentComponent(WebGroupBox3);
    WebEdit48.Name := 'WebEdit48';
    WebEdit48.Left := 281;
    WebEdit48.Top := 83;
    WebEdit48.Width := 60;
    WebEdit48.Height := 19;
    WebEdit48.ChildOrder := 3;
    WebEdit48.Color := clAqua;
    WebEdit48.Enabled := False;
    WebEdit48.Font.Charset := DEFAULT_CHARSET;
    WebEdit48.Font.Color := clWindowText;
    WebEdit48.Font.Height := 11;
    WebEdit48.Font.Name := 'Tahoma';
    WebEdit48.Font.Style := [];
    WebEdit48.ParentFont := False;
    WebEdit48.Text := '0';
    WebEdit49.SetParentComponent(WebGroupBox3);
    WebEdit49.Name := 'WebEdit49';
    WebEdit49.Left := 281;
    WebEdit49.Top := 103;
    WebEdit49.Width := 60;
    WebEdit49.Height := 19;
    WebEdit49.ChildOrder := 4;
    WebEdit49.Color := clAqua;
    WebEdit49.Enabled := False;
    WebEdit49.Font.Charset := DEFAULT_CHARSET;
    WebEdit49.Font.Color := clWindowText;
    WebEdit49.Font.Height := 11;
    WebEdit49.Font.Name := 'Tahoma';
    WebEdit49.Font.Style := [];
    WebEdit49.ParentFont := False;
    WebEdit49.Text := '0';
    WebEdit51.SetParentComponent(WebGroupBox3);
    WebEdit51.Name := 'WebEdit51';
    WebEdit51.Left := 281;
    WebEdit51.Top := 124;
    WebEdit51.Width := 60;
    WebEdit51.Height := 19;
    WebEdit51.ChildOrder := 5;
    WebEdit51.Color := clAqua;
    WebEdit51.Enabled := False;
    WebEdit51.Font.Charset := DEFAULT_CHARSET;
    WebEdit51.Font.Color := clWindowText;
    WebEdit51.Font.Height := 11;
    WebEdit51.Font.Name := 'Tahoma';
    WebEdit51.Font.Style := [];
    WebEdit51.ParentFont := False;
    WebEdit51.Text := '0';
    WebEdit1.SetParentComponent(WebGroupBox3);
    WebEdit1.Name := 'WebEdit1';
    WebEdit1.Left := 281;
    WebEdit1.Top := 41;
    WebEdit1.Width := 60;
    WebEdit1.Height := 19;
    WebEdit1.ChildOrder := 16;
    WebEdit1.Color := clAqua;
    WebEdit1.Enabled := False;
    WebEdit1.Text := '0';
  finally
    WebLabel1.AfterLoadDFMValues;
    WebImageControl1.AfterLoadDFMValues;
    WebLabel11.AfterLoadDFMValues;
    WebLabel15.AfterLoadDFMValues;
    WebLabel12.AfterLoadDFMValues;
    WebLabel17.AfterLoadDFMValues;
    WebImageControl2.AfterLoadDFMValues;
    WebLabel18.AfterLoadDFMValues;
    WebLabel16.AfterLoadDFMValues;
    WebLabel37.AfterLoadDFMValues;
    WebGroupBox1.AfterLoadDFMValues;
    WebLabel19.AfterLoadDFMValues;
    WebLabel20.AfterLoadDFMValues;
    WebLabel21.AfterLoadDFMValues;
    WebLabel22.AfterLoadDFMValues;
    WebLabel23.AfterLoadDFMValues;
    WebLabel24.AfterLoadDFMValues;
    WebLabel25.AfterLoadDFMValues;
    WebLabel26.AfterLoadDFMValues;
    WebLabel27.AfterLoadDFMValues;
    WebLabel28.AfterLoadDFMValues;
    WebLabel29.AfterLoadDFMValues;
    WebLabel80.AfterLoadDFMValues;
    WebLabel81.AfterLoadDFMValues;
    WebLabel82.AfterLoadDFMValues;
    WebLabel83.AfterLoadDFMValues;
    WebEdit4.AfterLoadDFMValues;
    WebEdit5.AfterLoadDFMValues;
    WebEdit6.AfterLoadDFMValues;
    WebEdit7.AfterLoadDFMValues;
    WebEdit8.AfterLoadDFMValues;
    WebEdit9.AfterLoadDFMValues;
    WebEdit10.AfterLoadDFMValues;
    WebEdit11.AfterLoadDFMValues;
    WebEdit12.AfterLoadDFMValues;
    WebEdit13.AfterLoadDFMValues;
    WebEdit14.AfterLoadDFMValues;
    WebEdit15.AfterLoadDFMValues;
    WebEdit16.AfterLoadDFMValues;
    WebEdit17.AfterLoadDFMValues;
    WebEdit18.AfterLoadDFMValues;
    WebEdit19.AfterLoadDFMValues;
    WebEdit20.AfterLoadDFMValues;
    WebEdit21.AfterLoadDFMValues;
    WebEdit22.AfterLoadDFMValues;
    WebEdit23.AfterLoadDFMValues;
    WebEdit24.AfterLoadDFMValues;
    WebEdit25.AfterLoadDFMValues;
    WebEdit26.AfterLoadDFMValues;
    WebEdit27.AfterLoadDFMValues;
    WebEdit28.AfterLoadDFMValues;
    WebEdit29.AfterLoadDFMValues;
    WebEdit30.AfterLoadDFMValues;
    WebEdit31.AfterLoadDFMValues;
    WebEdit32.AfterLoadDFMValues;
    WebEdit33.AfterLoadDFMValues;
    WebEdit34.AfterLoadDFMValues;
    WebEdit35.AfterLoadDFMValues;
    WebEdit36.AfterLoadDFMValues;
    WebEdit37.AfterLoadDFMValues;
    WebEdit38.AfterLoadDFMValues;
    WebEdit39.AfterLoadDFMValues;
    WebEdit40.AfterLoadDFMValues;
    WebEdit41.AfterLoadDFMValues;
    WebEdit42.AfterLoadDFMValues;
    WebEdit43.AfterLoadDFMValues;
    WebEdit44.AfterLoadDFMValues;
    WebEdit45.AfterLoadDFMValues;
    WebEdit46.AfterLoadDFMValues;
    WebEdit3.AfterLoadDFMValues;
    WebGroupBox2.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    WebLabel3.AfterLoadDFMValues;
    WebLabel14.AfterLoadDFMValues;
    WebLabel4.AfterLoadDFMValues;
    WebLabel6.AfterLoadDFMValues;
    WebLabel5.AfterLoadDFMValues;
    WebLabel9.AfterLoadDFMValues;
    WebLabel36.AfterLoadDFMValues;
    WebComboBox3.AfterLoadDFMValues;
    WebComboBox1.AfterLoadDFMValues;
    WebComboBox2.AfterLoadDFMValues;
    WebComboBox4.AfterLoadDFMValues;
    WebComboBox5.AfterLoadDFMValues;
    WebGroupBox3.AfterLoadDFMValues;
    WebLabel30.AfterLoadDFMValues;
    WebLabel31.AfterLoadDFMValues;
    WebLabel32.AfterLoadDFMValues;
    WebLabel33.AfterLoadDFMValues;
    WebLabel34.AfterLoadDFMValues;
    WebLabel35.AfterLoadDFMValues;
    WebLabel38.AfterLoadDFMValues;
    WebLabel39.AfterLoadDFMValues;
    WebLabel7.AfterLoadDFMValues;
    WebLabel8.AfterLoadDFMValues;
    WebLabel10.AfterLoadDFMValues;
    WebLabel13.AfterLoadDFMValues;
    WebEdit2.AfterLoadDFMValues;
    WebEdit47.AfterLoadDFMValues;
    WebEdit48.AfterLoadDFMValues;
    WebEdit49.AfterLoadDFMValues;
    WebEdit51.AfterLoadDFMValues;
    WebEdit1.AfterLoadDFMValues;
  end;
end;

end.
